var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    viewBox: "0 0 150 37.5",
    height: 37.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.371094 27 L 7.507812 27 L 7.507812 27.128906 L 7.371094 27.128906 Z M 7.371094 27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.507812 27.09375 C 7.46875 27.03125 7.429688 26.96875 7.390625 26.902344 C 7.429688 26.96875 7.46875 27.03125 7.507812 27.09375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.261719 28.15625 L 8.328125 28.15625 L 8.328125 28.226562 L 8.261719 28.226562 Z M 8.261719 28.15625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.285156 28.191406 C 8.28125 28.1875 8.277344 28.179688 8.273438 28.175781 C 8.277344 28.179688 8.28125 28.1875 8.285156 28.191406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.125 28 L 8.191406 28 L 8.191406 28.089844 L 8.125 28.089844 Z M 8.125 28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.167969 28.042969 C 8.15625 28.027344 8.144531 28.011719 8.132812 27.996094 C 8.144531 28.011719 8.15625 28.027344 8.167969 28.042969"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 6 L 22.699219 6 L 22.699219 30.683594 L 2 30.683594 Z M 2 6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.636719 9.449219 C 22.535156 9.347656 22.429688 9.253906 22.316406 9.164062 C 22.304688 9.152344 22.289062 9.144531 22.273438 9.132812 C 22.261719 9.125 22.246094 9.113281 22.230469 9.101562 C 22.179688 9.0625 22.128906 9.027344 22.078125 8.988281 C 22.023438 8.949219 21.96875 8.910156 21.914062 8.875 C 21.898438 8.867188 21.882812 8.855469 21.871094 8.847656 C 21.855469 8.839844 21.839844 8.832031 21.828125 8.824219 C 21.757812 8.78125 21.691406 8.742188 21.625 8.703125 C 21.578125 8.679688 21.535156 8.652344 21.488281 8.628906 C 21.472656 8.621094 21.453125 8.613281 21.433594 8.605469 C 21.421875 8.601562 21.410156 8.59375 21.398438 8.589844 C 21.3125 8.546875 21.226562 8.507812 21.140625 8.46875 C 21.109375 8.457031 21.078125 8.445312 21.046875 8.429688 L 21.039062 8.429688 C 20.460938 8.203125 19.851562 8.089844 19.242188 8.089844 C 18.96875 8.089844 18.695312 8.113281 18.425781 8.15625 C 17.726562 8.199219 17.035156 8.375 16.40625 8.6875 C 16.113281 8.832031 15.832031 9.007812 15.570312 9.214844 C 15.441406 9.316406 15.316406 9.425781 15.195312 9.542969 C 15.164062 9.574219 15.132812 9.605469 15.101562 9.636719 C 14.964844 9.773438 14.84375 9.910156 14.738281 10.046875 C 14.722656 10.070312 14.699219 10.089844 14.683594 10.113281 C 14.648438 10.164062 14.617188 10.210938 14.585938 10.261719 C 14.5625 10.289062 14.539062 10.320312 14.519531 10.351562 C 14.488281 10.402344 14.464844 10.453125 14.4375 10.503906 C 14.421875 10.53125 14.402344 10.5625 14.390625 10.589844 C 14.355469 10.65625 14.332031 10.71875 14.304688 10.78125 C 14.300781 10.796875 14.292969 10.8125 14.285156 10.828125 C 14.261719 10.890625 14.246094 10.953125 14.226562 11.015625 C 14.222656 11.03125 14.214844 11.050781 14.210938 11.066406 C 14.195312 11.125 14.183594 11.183594 14.171875 11.246094 C 14.167969 11.265625 14.164062 11.285156 14.160156 11.304688 C 14.152344 11.363281 14.148438 11.417969 14.144531 11.472656 C 14.140625 11.496094 14.136719 11.519531 14.136719 11.542969 C 14.136719 11.542969 14.019531 11.535156 13.804688 11.535156 C 12.265625 11.535156 5.804688 11.96875 4.582031 19.140625 C 4.464844 19.828125 4.410156 20.476562 4.410156 21.089844 C 4.410156 27.359375 9.96875 29.898438 9.996094 29.910156 C 9.992188 29.910156 9.988281 29.910156 9.988281 29.910156 C 9.988281 29.910156 10.101562 29.914062 10.140625 29.914062 C 10.183594 29.917969 10.222656 29.917969 10.261719 29.917969 C 12.089844 29.917969 12.484375 28.40625 12.484375 26.273438 C 12.484375 25.464844 12.425781 24.5625 12.371094 23.625 C 12.3125 22.683594 12.257812 21.703125 12.257812 20.726562 C 12.257812 17.976562 12.703125 15.277344 14.855469 13.691406 C 14.859375 13.699219 14.863281 13.707031 14.867188 13.710938 C 14.890625 13.746094 14.910156 13.777344 14.933594 13.808594 C 14.960938 13.851562 14.988281 13.894531 15.019531 13.933594 C 15.042969 13.96875 15.066406 14.003906 15.089844 14.035156 C 15.121094 14.082031 15.15625 14.128906 15.191406 14.175781 C 15.226562 14.226562 15.265625 14.277344 15.300781 14.324219 C 15.335938 14.371094 15.371094 14.414062 15.40625 14.460938 C 15.433594 14.496094 15.464844 14.535156 15.496094 14.574219 C 15.523438 14.609375 15.554688 14.648438 15.585938 14.6875 C 15.617188 14.726562 15.648438 14.761719 15.679688 14.800781 C 15.710938 14.839844 15.742188 14.878906 15.777344 14.917969 C 15.835938 14.988281 15.898438 15.0625 15.960938 15.136719 C 15.984375 15.164062 16.011719 15.191406 16.035156 15.21875 C 16.078125 15.269531 16.121094 15.320312 16.164062 15.367188 C 16.183594 15.390625 16.203125 15.410156 16.222656 15.433594 C 16.875 16.171875 17.613281 16.941406 18.324219 17.753906 L 18.332031 17.761719 C 18.5 17.949219 18.660156 18.140625 18.820312 18.332031 C 18.832031 18.34375 18.839844 18.351562 18.847656 18.363281 C 18.917969 18.449219 18.988281 18.535156 19.058594 18.621094 C 19.066406 18.632812 19.078125 18.644531 19.085938 18.65625 C 19.238281 18.847656 19.386719 19.039062 19.53125 19.230469 C 19.542969 19.25 19.558594 19.265625 19.570312 19.285156 C 19.632812 19.367188 19.691406 19.449219 19.75 19.535156 C 19.761719 19.550781 19.773438 19.566406 19.785156 19.578125 C 19.851562 19.679688 19.921875 19.777344 19.988281 19.878906 L 19.996094 19.894531 C 20.058594 19.984375 20.117188 20.078125 20.175781 20.167969 C 20.1875 20.191406 20.203125 20.214844 20.21875 20.238281 C 20.269531 20.320312 20.320312 20.40625 20.371094 20.492188 C 20.378906 20.507812 20.386719 20.523438 20.394531 20.539062 C 20.453125 20.640625 20.511719 20.742188 20.566406 20.84375 C 20.574219 20.859375 20.582031 20.875 20.589844 20.890625 C 20.636719 20.976562 20.679688 21.0625 20.722656 21.148438 C 20.734375 21.175781 20.746094 21.199219 20.757812 21.226562 C 20.800781 21.316406 20.84375 21.410156 20.882812 21.5 C 20.886719 21.511719 20.894531 21.523438 20.898438 21.539062 C 20.945312 21.640625 20.984375 21.746094 21.027344 21.851562 C 21.035156 21.875 21.042969 21.898438 21.050781 21.921875 C 21.082031 22.003906 21.113281 22.089844 21.140625 22.175781 C 21.148438 22.203125 21.160156 22.230469 21.167969 22.257812 C 21.199219 22.359375 21.230469 22.460938 21.257812 22.566406 L 21.261719 22.582031 C 21.289062 22.691406 21.316406 22.796875 21.339844 22.910156 C 21.34375 22.9375 21.351562 22.964844 21.355469 22.992188 C 21.375 23.078125 21.390625 23.164062 21.402344 23.25 C 21.40625 23.28125 21.410156 23.308594 21.414062 23.335938 C 21.433594 23.449219 21.445312 23.5625 21.457031 23.675781 L 21.457031 23.679688 C 21.464844 23.789062 21.472656 23.902344 21.476562 24.015625 C 21.476562 24.046875 21.476562 24.078125 21.476562 24.109375 C 21.480469 24.144531 21.480469 24.183594 21.480469 24.21875 C 21.480469 24.273438 21.476562 24.324219 21.476562 24.378906 C 21.476562 24.40625 21.476562 24.4375 21.476562 24.464844 C 21.46875 24.582031 21.464844 24.699219 21.453125 24.816406 C 21.449219 24.832031 21.449219 24.847656 21.445312 24.863281 C 21.433594 24.964844 21.421875 25.070312 21.40625 25.175781 C 21.398438 25.210938 21.394531 25.242188 21.386719 25.277344 C 21.371094 25.371094 21.355469 25.46875 21.332031 25.5625 C 21.328125 25.589844 21.320312 25.621094 21.316406 25.648438 C 21.289062 25.769531 21.253906 25.890625 21.21875 26.015625 C 21.210938 26.039062 21.203125 26.066406 21.195312 26.089844 C 21.167969 26.191406 21.132812 26.289062 21.097656 26.390625 C 21.085938 26.429688 21.074219 26.464844 21.058594 26.503906 C 21.019531 26.605469 20.980469 26.707031 20.9375 26.8125 C 20.925781 26.835938 20.917969 26.863281 20.90625 26.886719 C 20.851562 27.011719 20.792969 27.140625 20.730469 27.269531 C 20.714844 27.300781 20.699219 27.332031 20.683594 27.367188 C 20.632812 27.464844 20.582031 27.566406 20.523438 27.667969 C 20.503906 27.707031 20.480469 27.746094 20.460938 27.785156 C 20.394531 27.902344 20.324219 28.019531 20.253906 28.136719 C 20.242188 28.152344 20.234375 28.167969 20.222656 28.183594 C 20.140625 28.316406 20.050781 28.453125 19.957031 28.585938 C 19.933594 28.625 19.90625 28.664062 19.878906 28.699219 C 19.808594 28.800781 19.730469 28.90625 19.652344 29.011719 C 19.625 29.050781 19.59375 29.089844 19.5625 29.128906 C 19.457031 29.269531 19.347656 29.40625 19.234375 29.546875 L 19.230469 29.546875 C 17.59375 30.304688 15.824219 30.683594 14.054688 30.683594 C 10.890625 30.683594 7.730469 29.476562 5.320312 27.0625 C 2.90625 24.652344 1.699219 21.488281 1.699219 18.328125 C 1.699219 15.167969 2.90625 12.003906 5.320312 9.59375 C 7.730469 7.179688 10.886719 5.976562 14.046875 5.976562 C 17.144531 5.976562 20.246094 7.132812 22.636719 9.449219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 12 L 26 12 L 26 28 L 22 28 Z M 22 12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.40625 18.332031 C 26.40625 21.492188 25.199219 24.652344 22.789062 27.0625 C 22.4375 27.417969 22.066406 27.742188 21.683594 28.042969 C 22.066406 27.742188 22.4375 27.417969 22.789062 27.0625 C 23.96875 25.886719 24.855469 24.523438 25.457031 23.070312 C 25.460938 23.0625 25.464844 23.058594 25.464844 23.050781 C 25.484375 23 25.503906 22.953125 25.523438 22.90625 C 25.605469 22.695312 25.683594 22.484375 25.753906 22.273438 C 25.769531 22.230469 25.78125 22.183594 25.796875 22.140625 C 25.875 21.894531 25.949219 21.648438 26.011719 21.402344 C 26.015625 21.382812 26.023438 21.359375 26.027344 21.335938 C 26.042969 21.277344 26.054688 21.222656 26.070312 21.164062 C 26.117188 20.957031 26.160156 20.746094 26.199219 20.535156 C 26.207031 20.484375 26.214844 20.4375 26.222656 20.386719 C 26.238281 20.304688 26.25 20.21875 26.261719 20.136719 C 26.289062 19.96875 26.308594 19.800781 26.328125 19.632812 C 26.328125 19.609375 26.332031 19.589844 26.335938 19.570312 C 26.34375 19.472656 26.351562 19.375 26.359375 19.277344 C 26.375 19.105469 26.382812 18.929688 26.386719 18.757812 C 26.390625 18.703125 26.390625 18.652344 26.390625 18.601562 C 26.390625 18.589844 26.390625 18.582031 26.390625 18.574219 C 26.394531 18.496094 26.394531 18.417969 26.394531 18.339844 C 26.394531 18.324219 26.394531 18.308594 26.394531 18.292969 C 26.394531 18.148438 26.394531 18.003906 26.386719 17.863281 C 26.386719 17.859375 26.386719 17.859375 26.386719 17.859375 C 26.386719 17.855469 26.386719 17.851562 26.386719 17.851562 C 26.386719 17.847656 26.386719 17.84375 26.386719 17.839844 C 26.386719 17.820312 26.386719 17.800781 26.386719 17.78125 C 26.375 17.511719 26.351562 17.242188 26.320312 16.972656 C 26.320312 16.945312 26.316406 16.917969 26.3125 16.890625 C 26.308594 16.863281 26.304688 16.835938 26.300781 16.808594 C 26.277344 16.625 26.253906 16.441406 26.222656 16.257812 C 26.210938 16.191406 26.199219 16.121094 26.1875 16.054688 C 26.183594 16.039062 26.183594 16.019531 26.179688 16 C 26.160156 15.894531 26.136719 15.789062 26.113281 15.679688 C 26.078125 15.527344 26.039062 15.371094 26 15.214844 C 25.984375 15.15625 25.96875 15.097656 25.953125 15.039062 C 25.921875 14.921875 25.886719 14.804688 25.851562 14.6875 C 25.8125 14.5625 25.773438 14.4375 25.730469 14.3125 C 25.726562 14.292969 25.722656 14.277344 25.714844 14.261719 C 25.628906 14.007812 25.527344 13.757812 25.421875 13.507812 C 25.410156 13.472656 25.390625 13.433594 25.375 13.398438 C 25.367188 13.375 25.355469 13.355469 25.347656 13.332031 C 25.296875 13.214844 25.242188 13.097656 25.1875 12.980469 C 25.132812 12.863281 25.074219 12.746094 25.015625 12.632812 C 25.007812 12.617188 25.003906 12.605469 24.996094 12.59375 C 24.871094 12.351562 24.734375 12.117188 24.589844 11.882812 C 24.582031 11.867188 24.574219 11.851562 24.5625 11.832031 C 25.792969 13.816406 26.40625 16.074219 26.40625 18.332031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.070312 24 L 6.207031 24 L 6.207031 24.121094 L 6.070312 24.121094 Z M 6.070312 24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.191406 24.09375 C 6.167969 24.003906 6.144531 23.910156 6.125 23.820312 C 6.144531 23.910156 6.167969 24.003906 6.191406 24.09375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.167969 26.515625 L 7.234375 26.515625 L 7.234375 26.582031 L 7.167969 26.582031 Z M 7.167969 26.515625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.183594 26.539062 C 7.179688 26.535156 7.179688 26.53125 7.175781 26.53125 C 7.179688 26.53125 7.179688 26.535156 7.183594 26.539062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 10 L 23.382812 10 L 23.382812 10.230469 L 23 10.230469 Z M 23 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.371094 10.222656 L 23.367188 10.214844 C 23.207031 10.03125 23.042969 9.851562 22.871094 9.671875 C 22.871094 9.671875 22.867188 9.671875 22.867188 9.671875 C 22.867188 9.667969 22.863281 9.667969 22.863281 9.667969 C 22.859375 9.664062 22.855469 9.65625 22.851562 9.652344 C 22.828125 9.632812 22.808594 9.613281 22.789062 9.59375 C 22.992188 9.796875 23.183594 10.007812 23.371094 10.222656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.082031 29.113281 L 9.21875 29.113281 L 9.21875 29.25 L 9.082031 29.25 Z M 9.082031 29.113281"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.191406 29.191406 C 9.171875 29.171875 9.148438 29.152344 9.128906 29.128906 C 9.148438 29.152344 9.171875 29.171875 9.191406 29.191406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.46875 28.429688 L 8.605469 28.429688 L 8.605469 28.636719 L 8.46875 28.636719 Z M 8.46875 28.429688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.601562 28.570312 C 8.566406 28.527344 8.527344 28.480469 8.488281 28.4375 C 8.527344 28.480469 8.566406 28.527344 8.601562 28.570312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.453125 10.296875 L 24.546875 10.296875 L 24.546875 11.804688 L 23.453125 11.804688 Z M 23.453125 10.296875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.519531 11.765625 C 24.507812 11.75 24.496094 11.730469 24.484375 11.714844 C 24.414062 11.601562 24.339844 11.488281 24.261719 11.375 C 24.351562 11.503906 24.4375 11.632812 24.519531 11.765625 M 23.621094 10.515625 C 23.582031 10.46875 23.542969 10.421875 23.503906 10.375 L 23.496094 10.367188 C 23.539062 10.417969 23.582031 10.464844 23.621094 10.515625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.386719 8.109375 L 20.851562 8.109375 L 20.851562 8.589844 L 18.386719 8.589844 Z M 18.386719 8.109375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.789062 8.539062 C 20.148438 8.277344 19.453125 8.148438 18.761719 8.148438 C 18.648438 8.148438 18.535156 8.148438 18.425781 8.15625 C 18.539062 8.148438 18.648438 8.148438 18.761719 8.148438 C 19.453125 8.148438 20.148438 8.277344 20.789062 8.539062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.789062 8.539062 C 20.148438 8.277344 19.453125 8.148438 18.761719 8.148438 C 18.648438 8.148438 18.535156 8.148438 18.425781 8.15625 C 18.539062 8.148438 18.648438 8.148438 18.761719 8.148438 C 19.453125 8.148438 20.148438 8.277344 20.789062 8.539062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.230469 8.34375 L 19.609375 9.722656 L 20.988281 8.34375 L 19.609375 6.964844 Z M 18.230469 8.34375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.210938 28.019531 L 21.742188 28.019531 L 21.742188 29.59375 L 19.210938 29.59375 Z M 19.210938 28.019531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.683594 28.042969 C 20.914062 28.648438 20.09375 29.152344 19.230469 29.546875 L 19.234375 29.546875 C 19.238281 29.546875 19.242188 29.542969 19.246094 29.539062 C 20.101562 29.144531 20.917969 28.644531 21.683594 28.042969"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.683594 28.042969 C 20.914062 28.648438 20.09375 29.152344 19.230469 29.546875 L 19.234375 29.546875 C 19.238281 29.546875 19.242188 29.542969 19.246094 29.539062 C 20.101562 29.144531 20.917969 28.644531 21.683594 28.042969"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.480469 28.796875 L 20.457031 30.773438 L 22.4375 28.796875 L 20.457031 26.816406 Z M 18.480469 28.796875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.097656 29 L 20.234375 29 L 20.234375 29.113281 L 20.097656 29.113281 Z M 20.097656 29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.167969 29.042969 C 20.15625 29.050781 20.144531 29.058594 20.132812 29.066406 C 20.144531 29.058594 20.15625 29.050781 20.167969 29.042969"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.167969 29.042969 C 20.15625 29.050781 20.144531 29.058594 20.132812 29.066406 C 20.144531 29.058594 20.15625 29.050781 20.167969 29.042969"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.117188 29.054688 L 20.148438 29.085938 L 20.179688 29.054688 L 20.148438 29.023438 Z M 20.117188 29.054688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.628906 9.410156 L 22.699219 9.410156 L 22.699219 9.546875 L 22.628906 9.546875 Z M 22.628906 9.410156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.695312 9.5 C 22.675781 9.480469 22.65625 9.46875 22.640625 9.449219 C 22.65625 9.46875 22.675781 9.480469 22.695312 9.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.695312 9.5 C 22.675781 9.480469 22.65625 9.46875 22.640625 9.449219 C 22.65625 9.46875 22.675781 9.480469 22.695312 9.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.617188 9.472656 L 22.667969 9.523438 L 22.71875 9.472656 L 22.667969 9.421875 Z M 22.617188 9.472656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.230469 22.410156 L 25.4375 22.410156 L 25.4375 22.820312 L 25.230469 22.820312 Z M 25.230469 22.410156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.382812 22.476562 C 25.347656 22.578125 25.3125 22.675781 25.273438 22.777344 C 25.3125 22.675781 25.347656 22.578125 25.382812 22.476562"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.382812 22.476562 C 25.347656 22.578125 25.3125 22.675781 25.273438 22.777344 C 25.3125 22.675781 25.347656 22.578125 25.382812 22.476562"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.121094 22.625 L 25.328125 22.832031 L 25.535156 22.625 L 25.328125 22.421875 Z M 25.121094 22.625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.015625 9 L 22.289062 9 L 22.289062 9.136719 L 22.015625 9.136719 Z M 22.015625 9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.230469 9.101562 C 22.179688 9.0625 22.128906 9.027344 22.078125 8.988281 C 22.128906 9.027344 22.179688 9.0625 22.230469 9.101562"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.386719 8.039062 L 21 8.039062 L 21 8.589844 L 18.386719 8.589844 Z M 18.386719 8.039062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.039062 8.429688 C 20.953125 8.460938 20.875 8.503906 20.789062 8.539062 C 20.148438 8.277344 19.453125 8.148438 18.761719 8.148438 C 18.648438 8.148438 18.539062 8.148438 18.425781 8.15625 C 18.695312 8.113281 18.96875 8.089844 19.242188 8.089844 C 19.851562 8.089844 20.460938 8.203125 21.039062 8.429688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.125 8.449219 L 21.398438 8.449219 L 21.398438 8.65625 L 21.125 8.65625 Z M 21.125 8.449219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.398438 8.589844 C 21.3125 8.546875 21.226562 8.507812 21.140625 8.46875 C 21.226562 8.507812 21.3125 8.546875 21.398438 8.589844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 15.15625 L 26.121094 15.15625 L 26.121094 15.703125 L 26 15.703125 Z M 26 15.15625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.113281 15.679688 C 26.078125 15.527344 26.039062 15.371094 26 15.214844 C 26.039062 15.371094 26.078125 15.527344 26.113281 15.679688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.210938 22.410156 L 25.503906 22.410156 L 25.503906 29.59375 L 19.210938 29.59375 Z M 19.210938 22.410156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.457031 23.070312 C 24.855469 24.523438 23.96875 25.886719 22.789062 27.0625 C 22.4375 27.417969 22.066406 27.742188 21.683594 28.042969 C 20.917969 28.644531 20.101562 29.144531 19.246094 29.539062 C 19.273438 29.527344 19.300781 29.515625 19.332031 29.503906 C 19.613281 29.367188 19.878906 29.222656 20.132812 29.066406 C 20.144531 29.058594 20.15625 29.050781 20.167969 29.042969 C 20.992188 28.535156 21.679688 27.914062 22.460938 27.128906 C 23.0625 26.527344 23.589844 25.878906 24.039062 25.195312 C 24.265625 24.851562 24.472656 24.5 24.660156 24.140625 C 24.847656 23.785156 25.019531 23.417969 25.167969 23.046875 C 25.203125 22.957031 25.238281 22.867188 25.273438 22.777344 C 25.3125 22.675781 25.347656 22.578125 25.382812 22.476562 C 25.417969 22.671875 25.441406 22.867188 25.457031 23.070312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.453125 10.367188 L 23.65625 10.367188 L 23.65625 10.570312 L 23.453125 10.570312 Z M 23.453125 10.367188"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.621094 10.519531 C 23.582031 10.46875 23.542969 10.421875 23.503906 10.375 C 23.542969 10.421875 23.582031 10.46875 23.621094 10.515625 C 23.621094 10.519531 23.621094 10.519531 23.621094 10.519531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.453125 10.367188 L 24 10.367188 L 24 11 L 23.453125 11 Z M 23.453125 10.367188"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.019531 11.027344 C 23.894531 10.855469 23.761719 10.683594 23.621094 10.519531 C 23.621094 10.519531 23.621094 10.519531 23.621094 10.515625 C 23.761719 10.683594 23.894531 10.855469 24.019531 11.027344 M 23.621094 10.515625 C 23.582031 10.46875 23.542969 10.421875 23.503906 10.375 C 23.542969 10.421875 23.582031 10.46875 23.621094 10.515625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.203125 11.324219 L 24.546875 11.324219 L 24.546875 11.734375 L 24.203125 11.734375 Z M 24.203125 11.324219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.484375 11.714844 C 24.414062 11.601562 24.339844 11.484375 24.261719 11.375 C 24.339844 11.488281 24.414062 11.601562 24.484375 11.714844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 11 L 24.546875 11 L 24.546875 11.734375 L 24 11.734375 Z M 24 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.484375 11.714844 C 24.414062 11.601562 24.339844 11.488281 24.261719 11.375 C 24.339844 11.488281 24.414062 11.601562 24.484375 11.714844 M 24.261719 11.375 C 24.1875 11.261719 24.113281 11.15625 24.035156 11.046875 C 24.113281 11.15625 24.1875 11.265625 24.261719 11.375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.503906 22.273438 L 25.777344 22.273438 L 25.777344 22.957031 L 25.503906 22.957031 Z M 25.503906 22.273438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.753906 22.273438 C 25.683594 22.484375 25.605469 22.695312 25.523438 22.90625 C 25.605469 22.695312 25.683594 22.484375 25.753906 22.273438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.050781 20.492188 L 26.257812 20.492188 L 26.257812 21 L 26.050781 21 Z M 26.050781 20.492188"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.199219 20.535156 C 26.160156 20.746094 26.117188 20.957031 26.070312 21.164062 C 26.117188 20.957031 26.160156 20.746094 26.199219 20.535156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 21.382812 L 26.050781 21.382812 L 26.050781 22 L 26 22 Z M 26 21.382812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.011719 21.402344 C 25.949219 21.648438 25.875 21.894531 25.796875 22.140625 C 25.875 21.894531 25.949219 21.648438 26.011719 21.402344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.257812 20 L 26.394531 20 L 26.394531 20.152344 L 26.257812 20.152344 Z M 26.257812 20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.328125 19.632812 C 26.308594 19.800781 26.289062 19.96875 26.261719 20.136719 C 26.289062 19.96875 26.308594 19.800781 26.328125 19.632812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 19 L 26.394531 19 L 26.394531 19.332031 L 26.324219 19.332031 Z M 26.324219 19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.386719 18.757812 C 26.382812 18.929688 26.375 19.105469 26.359375 19.277344 C 26.375 19.105469 26.382812 18.929688 26.386719 18.757812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 18 L 26.40625 18 L 26.40625 18.371094 L 26.324219 18.371094 Z M 26.324219 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.394531 18.292969 C 26.394531 18.308594 26.394531 18.324219 26.394531 18.339844 C 26.394531 18.324219 26.394531 18.308594 26.394531 18.292969 C 26.394531 18.140625 26.390625 17.992188 26.386719 17.839844 C 26.386719 17.84375 26.386719 17.847656 26.386719 17.851562 C 26.386719 17.851562 26.386719 17.855469 26.386719 17.859375 C 26.386719 17.859375 26.386719 17.859375 26.386719 17.863281 C 26.394531 18.003906 26.394531 18.148438 26.394531 18.292969"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 18 L 26.40625 18 L 26.40625 18.304688 L 26.324219 18.304688 Z M 26.324219 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.394531 18.292969 L 26.394531 18.292969 M 26.394531 18.292969 C 26.394531 18.148438 26.394531 18.003906 26.386719 17.863281 C 26.394531 18.003906 26.394531 18.148438 26.394531 18.292969 M 26.386719 17.859375 C 26.386719 17.855469 26.386719 17.851562 26.386719 17.851562 C 26.386719 17.851562 26.386719 17.855469 26.386719 17.859375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 18.304688 L 26.40625 18.304688 L 26.40625 18.578125 L 26.324219 18.578125 Z M 26.324219 18.304688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.394531 18.339844 C 26.394531 18.417969 26.394531 18.496094 26.390625 18.574219 C 26.394531 18.496094 26.394531 18.417969 26.394531 18.339844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.257812 17 L 26.394531 17 L 26.394531 17.824219 L 26.257812 17.824219 Z M 26.257812 17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.386719 17.78125 C 26.375 17.511719 26.351562 17.242188 26.320312 16.972656 C 26.351562 17.242188 26.375 17.511719 26.386719 17.78125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.121094 16.046875 L 26.257812 16.046875 L 26.257812 16.320312 L 26.121094 16.320312 Z M 26.121094 16.046875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.222656 16.257812 C 26.210938 16.191406 26.199219 16.121094 26.1875 16.054688 C 26.199219 16.121094 26.210938 16.191406 26.222656 16.257812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.761719 8.109375 L 25.4375 8.109375 L 25.4375 29.59375 L 14.761719 29.59375 Z M 14.761719 8.109375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.382812 22.476562 C 25.347656 22.578125 25.3125 22.675781 25.273438 22.777344 C 25.238281 22.867188 25.203125 22.957031 25.167969 23.046875 C 25.019531 23.417969 24.847656 23.785156 24.660156 24.140625 C 24.472656 24.5 24.265625 24.851562 24.039062 25.195312 C 23.589844 25.878906 23.0625 26.527344 22.460938 27.128906 C 21.679688 27.914062 20.992188 28.535156 20.167969 29.042969 C 20.15625 29.050781 20.144531 29.058594 20.132812 29.066406 C 19.878906 29.222656 19.613281 29.367188 19.332031 29.503906 C 19.300781 29.515625 19.269531 29.53125 19.238281 29.546875 C 19.234375 29.546875 19.234375 29.546875 19.234375 29.546875 L 19.230469 29.546875 C 19.234375 29.546875 19.234375 29.546875 19.234375 29.546875 C 21.140625 27.3125 21.863281 25.34375 21.863281 23.582031 C 21.863281 20.835938 20.101562 18.59375 18.339844 16.640625 C 16.578125 14.6875 14.816406 13.015625 14.816406 11.410156 C 14.816406 10.800781 15.070312 10.195312 15.675781 9.589844 C 15.707031 9.5625 15.738281 9.53125 15.769531 9.5 C 16.523438 8.761719 17.457031 8.316406 18.425781 8.15625 C 18.535156 8.148438 18.648438 8.148438 18.761719 8.148438 C 19.453125 8.148438 20.148438 8.277344 20.789062 8.539062 C 20.285156 8.769531 19.804688 9.085938 19.382812 9.5 C 19.351562 9.53125 19.320312 9.5625 19.289062 9.589844 C 19.289062 9.59375 19.289062 9.59375 19.285156 9.59375 C 19.285156 9.597656 19.28125 9.601562 19.28125 9.601562 C 18.683594 10.203125 18.429688 10.800781 18.429688 11.410156 C 18.429688 12.59375 19.382812 13.808594 20.589844 15.144531 C 22.433594 17.195312 24.871094 19.53125 25.382812 22.476562 M 24.039062 25.195312 C 24.265625 24.851562 24.472656 24.5 24.660156 24.140625 C 24.472656 24.5 24.265625 24.851562 24.039062 25.195312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.382812 22.476562 C 25.347656 22.578125 25.3125 22.675781 25.273438 22.777344 C 25.238281 22.867188 25.203125 22.957031 25.167969 23.046875 C 25.019531 23.417969 24.847656 23.785156 24.660156 24.140625 C 24.472656 24.5 24.265625 24.851562 24.039062 25.195312 C 23.589844 25.878906 23.0625 26.527344 22.460938 27.128906 C 21.679688 27.914062 20.992188 28.535156 20.167969 29.042969 C 20.15625 29.050781 20.144531 29.058594 20.132812 29.066406 C 19.878906 29.222656 19.613281 29.367188 19.332031 29.503906 C 19.300781 29.515625 19.269531 29.53125 19.238281 29.546875 C 19.234375 29.546875 19.234375 29.546875 19.234375 29.546875 L 19.230469 29.546875 C 19.234375 29.546875 19.234375 29.546875 19.234375 29.546875 C 21.140625 27.3125 21.863281 25.34375 21.863281 23.582031 C 21.863281 20.835938 20.101562 18.59375 18.339844 16.640625 C 16.578125 14.6875 14.816406 13.015625 14.816406 11.410156 C 14.816406 10.800781 15.070312 10.195312 15.675781 9.589844 C 15.707031 9.5625 15.738281 9.53125 15.769531 9.5 C 16.523438 8.761719 17.457031 8.316406 18.425781 8.15625 C 18.535156 8.148438 18.648438 8.148438 18.761719 8.148438 C 19.453125 8.148438 20.148438 8.277344 20.789062 8.539062 C 20.285156 8.769531 19.804688 9.085938 19.382812 9.5 C 19.351562 9.53125 19.320312 9.5625 19.289062 9.589844 C 19.289062 9.59375 19.289062 9.59375 19.285156 9.59375 C 19.285156 9.597656 19.28125 9.601562 19.28125 9.601562 C 18.683594 10.203125 18.429688 10.800781 18.429688 11.410156 C 18.429688 12.59375 19.382812 13.808594 20.589844 15.144531 C 22.433594 17.195312 24.871094 19.53125 25.382812 22.476562 M 24.039062 25.195312 C 24.265625 24.851562 24.472656 24.5 24.660156 24.140625 C 24.472656 24.5 24.265625 24.851562 24.039062 25.195312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.117188 18.847656 L 20.097656 34.832031 L 36.082031 18.847656 L 20.097656 2.863281 Z M 4.117188 18.847656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 24.121094 L 24.683594 24.121094 L 24.683594 25 L 24 25 Z M 24 24.121094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.660156 24.140625 C 24.472656 24.5 24.265625 24.851562 24.039062 25.195312 C 24.265625 24.851562 24.472656 24.5 24.660156 24.140625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.160156 23 L 25.300781 23 L 25.300781 23.09375 L 25.160156 23.09375 Z M 25.160156 23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.273438 22.777344 C 25.238281 22.867188 25.203125 22.957031 25.167969 23.046875 C 25.203125 22.957031 25.238281 22.867188 25.273438 22.777344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.167969 27.0625 L 22.492188 27.0625 L 22.492188 29.046875 L 20.167969 29.046875 Z M 20.167969 27.0625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.460938 27.128906 C 21.679688 27.914062 20.992188 28.535156 20.167969 29.042969 C 20.992188 28.535156 21.679688 27.914062 22.460938 27.128906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.460938 27.128906 C 21.679688 27.914062 20.992188 28.535156 20.167969 29.042969 C 20.992188 28.535156 21.679688 27.914062 22.460938 27.128906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.210938 28.085938 L 21.316406 30.191406 L 23.417969 28.085938 L 21.316406 25.984375 Z M 19.210938 28.085938"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.277344 29.046875 L 20.167969 29.046875 L 20.167969 29.523438 L 19.277344 29.523438 Z M 19.277344 29.046875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.132812 29.066406 C 19.878906 29.222656 19.613281 29.367188 19.332031 29.503906 C 19.613281 29.367188 19.878906 29.222656 20.132812 29.066406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.132812 29.066406 C 19.878906 29.222656 19.613281 29.367188 19.332031 29.503906 C 19.613281 29.367188 19.878906 29.222656 20.132812 29.066406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.113281 29.285156 L 19.730469 29.902344 L 20.347656 29.285156 L 19.730469 28.667969 Z M 19.113281 29.285156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.210938 29.523438 L 19.277344 29.523438 L 19.277344 29.59375 L 19.210938 29.59375 Z M 19.210938 29.523438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.246094 29.539062 C 19.242188 29.542969 19.238281 29.546875 19.234375 29.546875 C 19.234375 29.546875 19.234375 29.546875 19.238281 29.546875 C 19.238281 29.542969 19.242188 29.542969 19.246094 29.539062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.210938 29.457031 L 19.347656 29.457031 L 19.347656 29.59375 L 19.210938 29.59375 Z M 19.210938 29.457031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.332031 29.503906 C 19.300781 29.515625 19.273438 29.527344 19.246094 29.539062 C 19.242188 29.542969 19.238281 29.542969 19.238281 29.546875 C 19.269531 29.53125 19.300781 29.515625 19.332031 29.503906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.414062 10.269531 L 23.496094 10.269531 L 23.496094 10.367188 L 23.414062 10.367188 Z M 23.414062 10.269531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.496094 10.367188 C 23.46875 10.332031 23.441406 10.300781 23.414062 10.269531 C 23.441406 10.300781 23.46875 10.332031 23.496094 10.367188"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.496094 10.367188 C 23.46875 10.332031 23.441406 10.300781 23.414062 10.269531 C 23.441406 10.300781 23.46875 10.332031 23.496094 10.367188"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.535156 11.789062 L 24.5625 11.789062 L 24.5625 11.832031 L 24.535156 11.832031 Z M 24.535156 11.789062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.5625 11.832031 C 24.550781 11.816406 24.542969 11.804688 24.535156 11.789062 C 24.542969 11.804688 24.550781 11.816406 24.5625 11.832031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.5625 11.832031 C 24.550781 11.816406 24.542969 11.804688 24.535156 11.789062 C 24.542969 11.804688 24.550781 11.816406 24.5625 11.832031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.316406 10.160156 L 23.519531 10.160156 L 23.519531 10.433594 L 23.316406 10.433594 Z M 23.316406 10.160156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.503906 10.375 C 23.457031 10.320312 23.414062 10.269531 23.367188 10.214844 L 23.371094 10.222656 C 23.386719 10.238281 23.398438 10.253906 23.414062 10.269531 C 23.398438 10.253906 23.386719 10.238281 23.371094 10.222656 C 23.386719 10.238281 23.398438 10.253906 23.414062 10.269531 C 23.441406 10.300781 23.46875 10.332031 23.496094 10.367188 L 23.503906 10.375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.316406 10.160156 L 23.519531 10.160156 L 23.519531 10.367188 L 23.316406 10.367188 Z M 23.316406 10.160156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.496094 10.367188 C 23.46875 10.332031 23.441406 10.300781 23.414062 10.269531 C 23.441406 10.300781 23.46875 10.332031 23.496094 10.367188 M 23.414062 10.269531 C 23.398438 10.253906 23.386719 10.238281 23.371094 10.222656 C 23.386719 10.238281 23.398438 10.253906 23.414062 10.269531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.4375 23.023438 L 25.503906 23.023438 L 25.503906 23.09375 L 25.4375 23.09375 Z M 25.4375 23.023438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.464844 23.050781 C 25.464844 23.058594 25.460938 23.0625 25.457031 23.070312 C 25.460938 23.0625 25.464844 23.054688 25.464844 23.050781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.121094 16 L 26.1875 16 L 26.1875 16.113281 L 26.121094 16.113281 Z M 26.121094 16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.1875 16.054688 C 26.183594 16.039062 26.183594 16.019531 26.179688 16 C 26.183594 16.019531 26.183594 16.039062 26.1875 16.054688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.367188 13.378906 L 25.4375 13.378906 L 25.4375 13.515625 L 25.367188 13.515625 Z M 25.367188 13.378906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.421875 13.507812 C 25.410156 13.472656 25.390625 13.433594 25.375 13.398438 C 25.390625 13.433594 25.410156 13.472656 25.421875 13.507812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.21875 9.066406 L 22.289062 9.066406 L 22.289062 9.136719 L 22.21875 9.136719 Z M 22.21875 9.066406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.273438 9.132812 C 22.261719 9.125 22.246094 9.113281 22.230469 9.101562 C 22.246094 9.113281 22.261719 9.125 22.273438 9.132812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 8.519531 L 22 8.519531 L 22 9.613281 L 21 9.613281 Z M 21 8.519531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.410156 9.609375 C 22.398438 9.59375 22.382812 9.578125 22.367188 9.566406 C 21.910156 9.117188 21.371094 8.777344 20.789062 8.539062 C 21.371094 8.777344 21.910156 9.117188 22.367188 9.566406 C 22.382812 9.578125 22.398438 9.59375 22.410156 9.609375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.367188 21.382812 L 25.710938 21.382812 L 25.710938 22.476562 L 25.367188 22.476562 Z M 25.367188 21.382812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.691406 21.445312 C 25.605469 21.792969 25.5 22.136719 25.382812 22.476562 C 25.5 22.136719 25.605469 21.792969 25.691406 21.445312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 8.382812 L 26 8.382812 L 26 23 L 21 23 Z M 21 8.382812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.394531 18.292969 C 26.394531 18.308594 26.394531 18.324219 26.394531 18.339844 C 26.394531 18.421875 26.394531 18.5 26.390625 18.578125 C 26.390625 18.582031 26.390625 18.585938 26.390625 18.585938 C 26.390625 18.589844 26.390625 18.597656 26.390625 18.601562 C 26.390625 18.652344 26.390625 18.703125 26.386719 18.757812 C 26.382812 18.929688 26.375 19.105469 26.359375 19.277344 C 26.351562 19.375 26.34375 19.472656 26.335938 19.570312 C 26.332031 19.589844 26.328125 19.609375 26.328125 19.632812 C 26.308594 19.800781 26.289062 19.96875 26.261719 20.136719 C 26.25 20.21875 26.238281 20.304688 26.222656 20.386719 C 26.214844 20.4375 26.207031 20.484375 26.199219 20.535156 C 26.160156 20.746094 26.117188 20.957031 26.070312 21.164062 C 26.054688 21.222656 26.042969 21.277344 26.027344 21.335938 C 26.023438 21.359375 26.015625 21.382812 26.011719 21.402344 C 25.949219 21.648438 25.875 21.894531 25.796875 22.140625 C 25.78125 22.183594 25.769531 22.230469 25.753906 22.273438 C 25.683594 22.484375 25.605469 22.695312 25.523438 22.90625 C 25.503906 22.953125 25.484375 23 25.464844 23.050781 C 25.464844 23.054688 25.460938 23.0625 25.457031 23.070312 C 25.441406 22.867188 25.417969 22.671875 25.382812 22.476562 C 25.5 22.136719 25.605469 21.792969 25.691406 21.445312 C 25.699219 21.410156 25.710938 21.375 25.71875 21.335938 C 25.8125 20.949219 25.886719 20.5625 25.945312 20.167969 C 25.972656 19.972656 25.996094 19.777344 26.015625 19.578125 C 26.015625 19.570312 26.015625 19.558594 26.015625 19.550781 C 26.050781 19.164062 26.070312 18.78125 26.070312 18.394531 C 26.070312 17.996094 26.050781 17.601562 26.015625 17.207031 C 25.980469 16.84375 25.925781 16.476562 25.859375 16.117188 C 25.816406 15.894531 25.773438 15.671875 25.71875 15.449219 C 25.53125 14.675781 25.265625 13.917969 24.929688 13.1875 C 24.757812 12.820312 24.570312 12.460938 24.363281 12.113281 C 24.261719 11.9375 24.152344 11.761719 24.039062 11.59375 C 23.816406 11.25 23.570312 10.917969 23.308594 10.59375 C 23.175781 10.433594 23.039062 10.273438 22.898438 10.117188 C 22.894531 10.113281 22.894531 10.113281 22.890625 10.109375 C 22.894531 10.113281 22.894531 10.113281 22.898438 10.117188 C 22.894531 10.113281 22.894531 10.113281 22.890625 10.109375 C 22.894531 10.113281 22.894531 10.113281 22.898438 10.117188 C 22.894531 10.113281 22.894531 10.113281 22.890625 10.109375 C 22.753906 9.957031 22.609375 9.804688 22.460938 9.65625 C 22.445312 9.644531 22.433594 9.628906 22.417969 9.613281 C 22.417969 9.613281 22.414062 9.613281 22.414062 9.609375 C 22.414062 9.613281 22.417969 9.613281 22.417969 9.613281 C 22.417969 9.613281 22.414062 9.613281 22.414062 9.609375 C 22.414062 9.613281 22.417969 9.613281 22.417969 9.613281 C 22.417969 9.613281 22.414062 9.613281 22.414062 9.609375 C 22.414062 9.609375 22.414062 9.609375 22.410156 9.609375 C 22.398438 9.59375 22.382812 9.578125 22.367188 9.566406 C 21.910156 9.117188 21.371094 8.777344 20.789062 8.539062 C 20.875 8.503906 20.953125 8.460938 21.039062 8.429688 L 21.046875 8.429688 C 21.078125 8.445312 21.109375 8.457031 21.140625 8.46875 C 21.226562 8.507812 21.3125 8.546875 21.398438 8.589844 C 21.410156 8.59375 21.421875 8.601562 21.433594 8.605469 C 21.453125 8.613281 21.472656 8.621094 21.488281 8.628906 C 21.535156 8.652344 21.578125 8.679688 21.625 8.703125 C 21.691406 8.742188 21.757812 8.78125 21.828125 8.824219 C 21.839844 8.832031 21.855469 8.839844 21.871094 8.847656 C 21.882812 8.855469 21.898438 8.867188 21.914062 8.875 C 21.96875 8.910156 22.023438 8.949219 22.078125 8.988281 C 22.128906 9.027344 22.179688 9.0625 22.230469 9.101562 C 22.246094 9.113281 22.261719 9.125 22.273438 9.132812 C 22.289062 9.144531 22.304688 9.152344 22.316406 9.164062 C 22.429688 9.253906 22.535156 9.351562 22.640625 9.449219 C 22.6875 9.496094 22.738281 9.542969 22.785156 9.589844 C 22.785156 9.589844 22.789062 9.589844 22.789062 9.59375 C 22.789062 9.589844 22.785156 9.589844 22.785156 9.589844 C 22.785156 9.589844 22.789062 9.589844 22.789062 9.59375 C 22.808594 9.613281 22.828125 9.632812 22.851562 9.652344 C 22.855469 9.65625 22.859375 9.664062 22.863281 9.667969 C 22.863281 9.667969 22.867188 9.667969 22.867188 9.671875 C 22.867188 9.671875 22.871094 9.671875 22.871094 9.671875 C 23.042969 9.851562 23.207031 10.03125 23.367188 10.214844 C 23.414062 10.269531 23.457031 10.320312 23.503906 10.375 C 23.542969 10.421875 23.582031 10.46875 23.621094 10.519531 C 23.851562 10.796875 24.0625 11.082031 24.261719 11.375 C 24.339844 11.484375 24.414062 11.601562 24.484375 11.714844 C 24.519531 11.769531 24.554688 11.828125 24.589844 11.882812 C 24.734375 12.117188 24.871094 12.351562 24.996094 12.59375 C 25.003906 12.605469 25.007812 12.617188 25.015625 12.632812 C 25.074219 12.746094 25.132812 12.863281 25.1875 12.980469 C 25.242188 13.097656 25.296875 13.214844 25.347656 13.332031 C 25.355469 13.355469 25.367188 13.375 25.375 13.398438 C 25.390625 13.433594 25.410156 13.472656 25.421875 13.507812 C 25.527344 13.757812 25.628906 14.007812 25.714844 14.261719 C 25.722656 14.277344 25.726562 14.292969 25.730469 14.3125 C 25.773438 14.4375 25.8125 14.5625 25.851562 14.6875 C 25.886719 14.804688 25.921875 14.921875 25.953125 15.039062 C 25.96875 15.097656 25.984375 15.15625 26 15.214844 C 26.039062 15.371094 26.078125 15.527344 26.113281 15.679688 C 26.136719 15.789062 26.160156 15.894531 26.179688 16 C 26.183594 16.019531 26.183594 16.039062 26.1875 16.054688 C 26.199219 16.121094 26.210938 16.191406 26.222656 16.257812 C 26.253906 16.441406 26.277344 16.625 26.300781 16.808594 C 26.304688 16.835938 26.308594 16.863281 26.3125 16.890625 C 26.316406 16.917969 26.320312 16.945312 26.320312 16.972656 C 26.351562 17.242188 26.375 17.511719 26.386719 17.78125 C 26.386719 17.800781 26.386719 17.820312 26.386719 17.839844 C 26.390625 17.992188 26.394531 18.140625 26.394531 18.292969 M 25.71875 15.449219 C 25.773438 15.671875 25.816406 15.894531 25.859375 16.117188 C 25.816406 15.894531 25.773438 15.671875 25.71875 15.449219 M 25.71875 15.449219 C 25.773438 15.671875 25.816406 15.894531 25.859375 16.117188 C 25.816406 15.894531 25.773438 15.671875 25.71875 15.449219 M 24.363281 12.113281 C 24.570312 12.460938 24.757812 12.820312 24.929688 13.1875 C 24.757812 12.820312 24.570312 12.460938 24.363281 12.113281 M 24.363281 12.113281 C 24.570312 12.460938 24.757812 12.820312 24.929688 13.1875 C 24.757812 12.820312 24.570312 12.460938 24.363281 12.113281"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 13 L 26 13 L 26 22 L 25 22 Z M 25 13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.390625 18.574219 C 26.390625 18.582031 26.390625 18.589844 26.390625 18.601562 C 26.390625 18.652344 26.390625 18.703125 26.386719 18.757812 C 26.390625 18.703125 26.390625 18.652344 26.390625 18.601562 C 26.390625 18.589844 26.390625 18.582031 26.390625 18.574219 M 26.390625 18.601562 C 26.390625 18.652344 26.390625 18.703125 26.386719 18.757812 C 26.390625 18.703125 26.390625 18.652344 26.390625 18.601562 M 26.390625 18.578125 C 26.390625 18.582031 26.390625 18.585938 26.390625 18.585938 C 26.390625 18.585938 26.390625 18.582031 26.390625 18.578125 M 26.386719 17.839844 C 26.386719 17.820312 26.386719 17.800781 26.386719 17.78125 C 26.386719 17.800781 26.386719 17.820312 26.386719 17.839844 M 26.386719 17.839844 C 26.386719 17.820312 26.386719 17.800781 26.386719 17.78125 C 26.386719 17.800781 26.386719 17.820312 26.386719 17.839844 M 26.3125 16.890625 C 26.308594 16.863281 26.304688 16.835938 26.300781 16.808594 C 26.304688 16.835938 26.308594 16.863281 26.3125 16.890625 C 26.308594 16.863281 26.304688 16.835938 26.300781 16.808594 C 26.277344 16.625 26.253906 16.441406 26.222656 16.257812 C 26.253906 16.441406 26.277344 16.625 26.300781 16.808594 C 26.277344 16.625 26.253906 16.441406 26.222656 16.257812 C 26.253906 16.441406 26.277344 16.625 26.300781 16.808594 C 26.304688 16.835938 26.308594 16.863281 26.3125 16.890625 M 26.261719 20.136719 C 26.25 20.21875 26.238281 20.304688 26.222656 20.386719 C 26.214844 20.4375 26.207031 20.484375 26.199219 20.535156 C 26.207031 20.484375 26.214844 20.4375 26.222656 20.386719 C 26.238281 20.304688 26.25 20.21875 26.261719 20.136719 C 26.25 20.21875 26.238281 20.304688 26.222656 20.386719 C 26.238281 20.304688 26.25 20.21875 26.261719 20.136719 M 26.222656 20.386719 C 26.214844 20.4375 26.207031 20.484375 26.199219 20.535156 C 26.207031 20.484375 26.214844 20.4375 26.222656 20.386719 M 26.070312 21.164062 C 26.054688 21.222656 26.042969 21.277344 26.027344 21.335938 C 26.023438 21.359375 26.015625 21.382812 26.011719 21.402344 C 26.015625 21.382812 26.023438 21.359375 26.027344 21.335938 C 26.042969 21.277344 26.054688 21.222656 26.070312 21.164062 C 26.054688 21.222656 26.042969 21.277344 26.027344 21.335938 C 26.042969 21.277344 26.054688 21.222656 26.070312 21.164062 M 26.027344 21.335938 C 26.023438 21.359375 26.015625 21.382812 26.011719 21.402344 C 26.015625 21.382812 26.023438 21.359375 26.027344 21.335938 M 26 15.214844 C 25.984375 15.15625 25.96875 15.097656 25.953125 15.039062 C 25.921875 14.921875 25.886719 14.804688 25.851562 14.6875 C 25.886719 14.804688 25.921875 14.921875 25.953125 15.039062 C 25.921875 14.921875 25.886719 14.804688 25.851562 14.6875 C 25.886719 14.804688 25.921875 14.921875 25.953125 15.039062 C 25.96875 15.097656 25.984375 15.15625 26 15.214844 M 26 15.214844 C 25.984375 15.15625 25.96875 15.097656 25.953125 15.039062 C 25.96875 15.097656 25.984375 15.15625 26 15.214844 M 25.796875 22.140625 C 25.78125 22.183594 25.769531 22.230469 25.753906 22.273438 C 25.769531 22.230469 25.78125 22.183594 25.796875 22.140625 M 25.796875 22.140625 C 25.78125 22.183594 25.769531 22.230469 25.753906 22.273438 C 25.769531 22.230469 25.78125 22.183594 25.796875 22.140625 M 25.714844 14.261719 C 25.628906 14.007812 25.527344 13.757812 25.421875 13.507812 C 25.527344 13.757812 25.628906 14.007812 25.714844 14.261719 M 25.714844 14.261719 C 25.628906 14.007812 25.527344 13.757812 25.421875 13.507812 C 25.527344 13.757812 25.628906 14.007812 25.714844 14.261719 M 25.375 13.398438 C 25.367188 13.375 25.355469 13.355469 25.347656 13.332031 C 25.355469 13.355469 25.367188 13.375 25.375 13.398438 C 25.367188 13.375 25.355469 13.355469 25.347656 13.332031 C 25.296875 13.214844 25.242188 13.097656 25.1875 12.980469 C 25.242188 13.097656 25.296875 13.214844 25.347656 13.332031 C 25.296875 13.214844 25.242188 13.097656 25.1875 12.980469 C 25.242188 13.097656 25.296875 13.214844 25.347656 13.332031 C 25.355469 13.355469 25.367188 13.375 25.375 13.398438 M 25.015625 12.632812 C 25.007812 12.617188 25.003906 12.605469 24.996094 12.59375 C 25.003906 12.605469 25.007812 12.617188 25.015625 12.632812 M 25.015625 12.632812 C 25.007812 12.617188 25.003906 12.605469 24.996094 12.59375 C 25.003906 12.605469 25.007812 12.617188 25.015625 12.632812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 10.503906 L 24.273438 10.503906 L 24.273438 11 L 24 11 Z M 24 10.503906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.261719 11.375 C 24.0625 11.082031 23.851562 10.796875 23.621094 10.519531 C 23.761719 10.683594 23.894531 10.855469 24.019531 11.027344 C 24.023438 11.035156 24.03125 11.042969 24.035156 11.046875 C 24.113281 11.15625 24.1875 11.261719 24.261719 11.375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.367188 13.445312 L 25.777344 13.445312 L 25.777344 14 L 25.367188 14 Z M 25.367188 13.445312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.714844 14.261719 C 25.628906 14.007812 25.527344 13.757812 25.421875 13.507812 C 25.527344 13.757812 25.628906 14.007812 25.714844 14.261719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 8.382812 L 21.195312 8.382812 L 21.195312 8.519531 L 21 8.519531 Z M 21 8.382812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.140625 8.46875 C 21.109375 8.457031 21.078125 8.445312 21.046875 8.429688 C 21.078125 8.445312 21.109375 8.457031 21.140625 8.46875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.289062 9.136719 L 22.699219 9.136719 L 22.699219 9.476562 L 22.289062 9.476562 Z M 22.289062 9.136719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.640625 9.449219 C 22.535156 9.351562 22.429688 9.253906 22.316406 9.164062 C 22.429688 9.253906 22.535156 9.347656 22.636719 9.449219 C 22.636719 9.449219 22.636719 9.449219 22.640625 9.449219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 10 L 23.382812 10 L 23.382812 10.230469 L 23 10.230469 Z M 23 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.367188 10.214844 C 23.207031 10.03125 23.042969 9.851562 22.871094 9.671875 C 23.042969 9.851562 23.207031 10.03125 23.367188 10.214844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.160156 13 L 25.367188 13 L 25.367188 13.378906 L 25.160156 13.378906 Z M 25.160156 13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.347656 13.332031 C 25.296875 13.214844 25.242188 13.097656 25.1875 12.980469 C 25.242188 13.097656 25.296875 13.214844 25.347656 13.332031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.4375 23 L 25.574219 23 L 25.574219 23.09375 L 25.4375 23.09375 Z M 25.4375 23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.523438 22.90625 C 25.503906 22.953125 25.484375 23 25.464844 23.050781 C 25.484375 23 25.503906 22.953125 25.523438 22.90625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 21.109375 L 26.121094 21.109375 L 26.121094 21.382812 L 26 21.382812 Z M 26 21.109375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.070312 21.164062 C 26.054688 21.222656 26.042969 21.277344 26.027344 21.335938 C 26.042969 21.277344 26.054688 21.222656 26.070312 21.164062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.1875 20.082031 L 26.324219 20.082031 L 26.324219 20.425781 L 26.1875 20.425781 Z M 26.1875 20.082031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.261719 20.136719 C 26.25 20.21875 26.238281 20.304688 26.222656 20.386719 C 26.238281 20.304688 26.25 20.21875 26.261719 20.136719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 19.261719 L 26.394531 19.261719 L 26.394531 19.605469 L 26.324219 19.605469 Z M 26.324219 19.261719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.359375 19.277344 C 26.351562 19.375 26.34375 19.472656 26.335938 19.570312 C 26.34375 19.472656 26.351562 19.375 26.359375 19.277344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 18 L 26.40625 18 L 26.40625 18.304688 L 26.324219 18.304688 Z M 26.324219 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.394531 18.292969 L 26.394531 18.292969 M 26.394531 18.292969 C 26.394531 18.140625 26.390625 17.992188 26.386719 17.839844 C 26.390625 17.992188 26.394531 18.140625 26.394531 18.292969"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 18.304688 L 26.40625 18.304688 L 26.40625 18.644531 L 26.324219 18.644531 Z M 26.324219 18.304688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.394531 18.339844 C 26.394531 18.421875 26.394531 18.5 26.390625 18.578125 C 26.394531 18.5 26.394531 18.421875 26.394531 18.339844 M 26.390625 18.585938 C 26.390625 18.589844 26.390625 18.597656 26.390625 18.601562 C 26.390625 18.597656 26.390625 18.589844 26.390625 18.585938"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.324219 18.304688 L 26.40625 18.304688 L 26.40625 18.644531 L 26.324219 18.644531 Z M 26.324219 18.304688"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.394531 18.339844 C 26.394531 18.417969 26.394531 18.496094 26.390625 18.574219 C 26.390625 18.582031 26.390625 18.589844 26.390625 18.601562 C 26.390625 18.597656 26.390625 18.589844 26.390625 18.585938 C 26.390625 18.585938 26.390625 18.582031 26.390625 18.578125 C 26.394531 18.5 26.394531 18.421875 26.394531 18.339844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.1875 16.25 L 26.324219 16.25 L 26.324219 16.867188 L 26.1875 16.867188 Z M 26.1875 16.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.300781 16.808594 C 26.277344 16.625 26.253906 16.441406 26.222656 16.257812 C 26.253906 16.441406 26.277344 16.625 26.300781 16.808594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 21.316406 L 26.050781 21.316406 L 26.050781 21.453125 L 26 21.453125 Z M 26 21.316406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.027344 21.335938 C 26.023438 21.359375 26.015625 21.382812 26.011719 21.402344 C 26.015625 21.382812 26.023438 21.359375 26.027344 21.335938"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 11 L 24.066406 11 L 24.066406 11.050781 L 24 11.050781 Z M 24 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.035156 11.046875 C 24.03125 11.042969 24.023438 11.035156 24.019531 11.027344 C 24.023438 11.035156 24.03125 11.042969 24.035156 11.046875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.1875 20.355469 L 26.257812 20.355469 L 26.257812 20.5625 L 26.1875 20.5625 Z M 26.1875 20.355469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.222656 20.386719 C 26.214844 20.4375 26.207031 20.484375 26.199219 20.535156 C 26.207031 20.484375 26.214844 20.4375 26.222656 20.386719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.300781 13.308594 L 25.4375 13.308594 L 25.4375 13.445312 L 25.300781 13.445312 Z M 25.300781 13.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.375 13.398438 C 25.367188 13.375 25.355469 13.355469 25.347656 13.332031 C 25.355469 13.355469 25.367188 13.375 25.375 13.398438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.21875 9.066406 L 22.355469 9.066406 L 22.355469 9.203125 L 22.21875 9.203125 Z M 22.21875 9.066406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.316406 9.164062 C 22.304688 9.152344 22.289062 9.144531 22.273438 9.132812 C 22.289062 9.144531 22.304688 9.152344 22.316406 9.164062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.386719 8.519531 L 26 8.519531 L 26 22.476562 L 18.386719 22.476562 Z M 18.386719 8.519531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.070312 18.394531 C 26.070312 18.78125 26.050781 19.164062 26.015625 19.550781 C 26.015625 19.558594 26.015625 19.570312 26.015625 19.578125 C 25.996094 19.777344 25.972656 19.972656 25.945312 20.167969 C 25.886719 20.5625 25.8125 20.949219 25.71875 21.335938 C 25.710938 21.375 25.699219 21.410156 25.691406 21.445312 C 25.699219 21.410156 25.710938 21.375 25.71875 21.335938 C 25.710938 21.375 25.699219 21.410156 25.691406 21.445312 C 25.699219 21.410156 25.710938 21.375 25.71875 21.335938 C 25.625 21.722656 25.511719 22.101562 25.382812 22.476562 C 24.871094 19.53125 22.433594 17.195312 20.589844 15.144531 C 19.382812 13.808594 18.433594 12.59375 18.429688 11.410156 C 18.429688 10.800781 18.683594 10.203125 19.28125 9.601562 C 19.28125 9.601562 19.285156 9.597656 19.285156 9.59375 C 19.289062 9.59375 19.289062 9.59375 19.289062 9.589844 C 19.320312 9.5625 19.351562 9.53125 19.382812 9.5 C 19.804688 9.085938 20.285156 8.769531 20.789062 8.539062 C 21.371094 8.777344 21.910156 9.117188 22.367188 9.566406 C 22.382812 9.578125 22.398438 9.59375 22.410156 9.609375 C 22.414062 9.609375 22.414062 9.609375 22.414062 9.609375 C 22.414062 9.609375 22.414062 9.609375 22.410156 9.609375 C 22.414062 9.609375 22.414062 9.609375 22.414062 9.609375 C 22.414062 9.609375 22.414062 9.609375 22.410156 9.609375 C 22.414062 9.609375 22.414062 9.609375 22.414062 9.609375 C 22.414062 9.613281 22.417969 9.613281 22.417969 9.613281 C 22.433594 9.628906 22.445312 9.644531 22.460938 9.65625 C 22.609375 9.804688 22.753906 9.957031 22.890625 10.109375 C 22.894531 10.113281 22.894531 10.113281 22.898438 10.117188 C 23.039062 10.273438 23.175781 10.433594 23.308594 10.59375 C 23.308594 10.597656 23.3125 10.597656 23.3125 10.601562 C 23.3125 10.597656 23.308594 10.597656 23.308594 10.59375 C 23.308594 10.597656 23.3125 10.597656 23.3125 10.601562 C 23.3125 10.597656 23.308594 10.597656 23.308594 10.59375 C 23.570312 10.917969 23.816406 11.25 24.039062 11.59375 C 24.152344 11.761719 24.261719 11.9375 24.363281 12.113281 C 24.570312 12.460938 24.757812 12.820312 24.929688 13.1875 C 25.265625 13.917969 25.53125 14.675781 25.71875 15.449219 C 25.773438 15.671875 25.816406 15.894531 25.859375 16.117188 C 25.925781 16.476562 25.980469 16.84375 26.015625 17.207031 C 26.050781 17.601562 26.070312 17.996094 26.070312 18.394531 M 26.015625 19.578125 C 26.050781 19.183594 26.070312 18.789062 26.070312 18.394531 C 26.070312 18.789062 26.050781 19.183594 26.015625 19.578125 M 26.015625 19.578125 C 26.050781 19.183594 26.070312 18.789062 26.070312 18.394531 C 26.070312 18.789062 26.050781 19.183594 26.015625 19.578125 M 25.859375 16.117188 C 25.925781 16.476562 25.980469 16.84375 26.015625 17.207031 C 25.980469 16.84375 25.925781 16.476562 25.859375 16.117188 M 25.859375 16.117188 C 25.925781 16.476562 25.980469 16.84375 26.015625 17.207031 C 25.980469 16.84375 25.925781 16.476562 25.859375 16.117188 M 25.71875 21.335938 C 25.8125 20.949219 25.886719 20.5625 25.945312 20.167969 C 25.886719 20.5625 25.8125 20.949219 25.71875 21.335938 M 25.71875 21.335938 C 25.8125 20.949219 25.886719 20.5625 25.945312 20.167969 C 25.886719 20.5625 25.8125 20.949219 25.71875 21.335938"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.386719 10 L 20.644531 10 L 20.644531 15 L 18.386719 15 Z M 18.386719 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.589844 15.144531 C 19.382812 13.808594 18.429688 12.59375 18.429688 11.410156 C 18.433594 12.59375 19.382812 13.808594 20.589844 15.144531 M 19.285156 9.59375 C 19.285156 9.597656 19.28125 9.601562 19.28125 9.601562 C 19.28125 9.601562 19.285156 9.597656 19.285156 9.59375 M 18.429688 11.410156 L 18.429688 11.410156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.246094 11 L 24 11 L 24 11.597656 L 23.246094 11.597656 Z M 23.246094 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ct"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.039062 11.59375 C 23.816406 11.25 23.570312 10.917969 23.308594 10.59375 C 23.308594 10.597656 23.3125 10.597656 23.3125 10.601562 C 23.574219 10.921875 23.816406 11.253906 24.039062 11.59375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 16.113281 L 26.050781 16.113281 L 26.050781 17 L 26 17 Z M 26 16.113281"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.015625 17.207031 C 25.980469 16.84375 25.925781 16.476562 25.859375 16.117188 C 25.925781 16.476562 25.980469 16.84375 26.015625 17.207031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 18.371094 L 26.121094 18.371094 L 26.121094 19.605469 L 26 19.605469 Z M 26 18.371094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.070312 18.394531 C 26.070312 18.789062 26.050781 19.183594 26.015625 19.578125 C 26.050781 19.183594 26.070312 18.789062 26.070312 18.394531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.367188 21.316406 L 25.777344 21.316406 L 25.777344 22.476562 L 25.367188 22.476562 Z M 25.367188 21.316406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.71875 21.335938 C 25.710938 21.375 25.699219 21.410156 25.691406 21.445312 C 25.605469 21.792969 25.5 22.136719 25.382812 22.476562 C 25.511719 22.101562 25.625 21.722656 25.71875 21.335938"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 10.09375 L 26 10.09375 L 26 18 L 23 18 Z M 23 10.09375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.070312 18.394531 C 26.070312 17.996094 26.050781 17.601562 26.015625 17.207031 C 25.980469 16.84375 25.925781 16.476562 25.859375 16.117188 C 25.816406 15.894531 25.773438 15.671875 25.71875 15.449219 C 25.53125 14.675781 25.265625 13.917969 24.929688 13.1875 C 24.757812 12.820312 24.570312 12.460938 24.363281 12.113281 C 24.261719 11.9375 24.152344 11.761719 24.039062 11.59375 C 23.816406 11.253906 23.574219 10.921875 23.3125 10.601562 C 23.3125 10.597656 23.308594 10.597656 23.308594 10.59375 C 23.175781 10.433594 23.039062 10.273438 22.898438 10.117188 C 22.894531 10.113281 22.894531 10.113281 22.890625 10.109375 C 22.894531 10.113281 22.894531 10.113281 22.898438 10.117188 C 23.039062 10.273438 23.175781 10.433594 23.308594 10.59375 C 23.570312 10.917969 23.816406 11.25 24.039062 11.59375 C 24.152344 11.761719 24.261719 11.9375 24.363281 12.113281 C 24.570312 12.460938 24.757812 12.820312 24.929688 13.1875 C 25.265625 13.917969 25.53125 14.675781 25.71875 15.449219 C 25.773438 15.671875 25.816406 15.894531 25.859375 16.117188 C 25.925781 16.476562 25.980469 16.84375 26.015625 17.207031 C 26.050781 17.601562 26.070312 17.996094 26.070312 18.394531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.246094 11 L 24 11 L 24 11.597656 L 23.246094 11.597656 Z M 23.246094 11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.039062 11.59375 C 23.816406 11.253906 23.574219 10.921875 23.3125 10.601562 C 23.574219 10.921875 23.816406 11.253906 24.039062 11.59375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.339844 12.078125 L 24.957031 12.078125 L 24.957031 13 L 24.339844 13 Z M 24.339844 12.078125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.929688 13.1875 C 24.757812 12.820312 24.570312 12.460938 24.363281 12.113281 C 24.570312 12.460938 24.757812 12.820312 24.929688 13.1875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.355469 10 L 22.902344 10 L 22.902344 10.160156 L 22.355469 10.160156 Z M 22.355469 10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.890625 10.109375 C 22.753906 9.957031 22.609375 9.804688 22.460938 9.65625 C 22.445312 9.644531 22.433594 9.628906 22.417969 9.613281 C 22.433594 9.628906 22.445312 9.644531 22.460938 9.65625 C 22.609375 9.804688 22.753906 9.957031 22.890625 10.109375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.859375 19.308594 L 5.878906 19.308594 L 5.878906 19.539062 L 5.859375 19.539062 Z M 5.859375 19.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.878906 19.308594 C 5.871094 19.386719 5.867188 19.460938 5.859375 19.539062 C 5.867188 19.460938 5.871094 19.386719 5.878906 19.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.878906 19.308594 C 5.871094 19.386719 5.867188 19.460938 5.859375 19.539062 C 5.867188 19.460938 5.871094 19.386719 5.878906 19.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.628906 29.59375 L 9.765625 29.59375 L 9.765625 29.730469 L 9.628906 29.730469 Z M 9.628906 29.59375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.714844 29.671875 C 9.695312 29.65625 9.679688 29.640625 9.660156 29.621094 C 9.679688 29.640625 9.695312 29.65625 9.714844 29.671875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.714844 29.671875 C 9.695312 29.65625 9.679688 29.640625 9.660156 29.621094 C 9.679688 29.640625 9.695312 29.65625 9.714844 29.671875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.835938 29.800781 L 9.972656 29.800781 L 9.972656 29.867188 L 9.835938 29.867188 Z M 9.835938 29.800781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.914062 29.835938 C 9.90625 29.828125 9.894531 29.820312 9.886719 29.8125 C 9.894531 29.820312 9.90625 29.828125 9.914062 29.835938 M 9.882812 29.8125 L 9.882812 29.8125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.914062 29.835938 C 9.90625 29.828125 9.894531 29.820312 9.886719 29.8125 C 9.894531 29.820312 9.90625 29.828125 9.914062 29.835938 M 9.882812 29.8125 L 9.882812 29.8125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.539062 29.519531 L 9.585938 29.519531 L 9.585938 29.558594 L 9.539062 29.558594 Z M 9.539062 29.519531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.585938 29.558594 C 9.570312 29.546875 9.554688 29.53125 9.539062 29.519531 C 9.554688 29.53125 9.570312 29.546875 9.585938 29.558594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.585938 29.558594 C 9.570312 29.546875 9.554688 29.53125 9.539062 29.519531 C 9.554688 29.53125 9.570312 29.546875 9.585938 29.558594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.382812 29.375 L 9.4375 29.375 L 9.4375 29.425781 L 9.382812 29.425781 Z M 9.382812 29.375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.4375 29.425781 C 9.417969 29.410156 9.402344 29.394531 9.382812 29.375 C 9.402344 29.394531 9.417969 29.410156 9.4375 29.425781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.4375 29.425781 C 9.417969 29.410156 9.402344 29.394531 9.382812 29.375 C 9.402344 29.394531 9.417969 29.410156 9.4375 29.425781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.765625 29.730469 L 9.835938 29.730469 L 9.835938 29.800781 L 9.765625 29.800781 Z M 9.765625 29.730469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.824219 29.761719 C 9.816406 29.757812 9.808594 29.75 9.800781 29.742188 C 9.808594 29.75 9.816406 29.757812 9.824219 29.761719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.824219 29.761719 C 9.816406 29.757812 9.808594 29.75 9.800781 29.742188 C 9.808594 29.75 9.816406 29.757812 9.824219 29.761719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.972656 29.867188 L 10 29.867188 L 10 29.9375 L 9.972656 29.9375 Z M 9.972656 29.867188"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.996094 29.910156 L 9.992188 29.902344 L 9.996094 29.90625 L 9.996094 29.910156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.996094 29.910156 L 9.992188 29.902344 L 9.996094 29.90625 L 9.996094 29.910156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.003906 29.007812 L 9.09375 29.007812 L 9.09375 29.09375 L 9.003906 29.09375 Z M 9.003906 29.007812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.09375 29.09375 C 9.066406 29.066406 9.035156 29.035156 9.003906 29.007812 C 9.035156 29.035156 9.066406 29.066406 9.09375 29.09375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.09375 29.09375 C 9.066406 29.066406 9.035156 29.035156 9.003906 29.007812 C 9.035156 29.035156 9.066406 29.066406 9.09375 29.09375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.957031 23.035156 L 6.003906 23.035156 L 6.003906 23.289062 L 5.957031 23.289062 Z M 5.957031 23.035156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.003906 23.289062 C 5.988281 23.203125 5.972656 23.121094 5.957031 23.035156 C 5.972656 23.121094 5.988281 23.203125 6.003906 23.289062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "di"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.003906 23.289062 C 5.988281 23.203125 5.972656 23.121094 5.957031 23.035156 C 5.972656 23.121094 5.988281 23.203125 6.003906 23.289062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.691406 25.53125 L 6.773438 25.53125 L 6.773438 25.714844 L 6.691406 25.714844 Z M 6.691406 25.53125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.773438 25.714844 C 6.746094 25.652344 6.71875 25.59375 6.691406 25.53125 C 6.71875 25.59375 6.746094 25.65625 6.773438 25.714844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.773438 25.714844 C 6.746094 25.652344 6.71875 25.59375 6.691406 25.53125 C 6.71875 25.59375 6.746094 25.65625 6.773438 25.714844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.503906 25.0625 L 6.589844 25.0625 L 6.589844 25.277344 L 6.503906 25.277344 Z M 6.503906 25.0625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.589844 25.277344 C 6.5625 25.207031 6.53125 25.136719 6.503906 25.0625 C 6.53125 25.136719 6.5625 25.207031 6.589844 25.277344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "do"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.589844 25.277344 C 6.5625 25.207031 6.53125 25.136719 6.503906 25.0625 C 6.53125 25.136719 6.5625 25.207031 6.589844 25.277344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.339844 24.589844 L 6.378906 24.589844 L 6.378906 24.703125 L 6.339844 24.703125 Z M 6.339844 24.589844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.378906 24.703125 C 6.367188 24.664062 6.351562 24.628906 6.339844 24.589844 C 6.351562 24.628906 6.367188 24.664062 6.378906 24.703125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.378906 24.703125 C 6.367188 24.664062 6.351562 24.628906 6.339844 24.589844 C 6.351562 24.628906 6.367188 24.664062 6.378906 24.703125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.871094 22.46875 L 5.875 22.46875 L 5.875 22.5 L 5.871094 22.5 Z M 5.871094 22.46875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.875 22.5 C 5.875 22.488281 5.875 22.480469 5.871094 22.46875 C 5.875 22.480469 5.875 22.488281 5.875 22.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "du"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.875 22.5 C 5.875 22.488281 5.875 22.480469 5.871094 22.46875 C 5.875 22.480469 5.875 22.488281 5.875 22.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.824219 22.011719 L 5.839844 22.011719 L 5.839844 22.152344 L 5.824219 22.152344 Z M 5.824219 22.011719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.839844 22.152344 C 5.835938 22.105469 5.832031 22.058594 5.824219 22.011719 C 5.832031 22.058594 5.835938 22.105469 5.839844 22.152344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.839844 22.152344 C 5.835938 22.105469 5.832031 22.058594 5.824219 22.011719 C 5.832031 22.058594 5.835938 22.105469 5.839844 22.152344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.875 25.941406 L 6.96875 25.941406 L 6.96875 26.128906 L 6.875 26.128906 Z M 6.875 25.941406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.96875 26.128906 C 6.9375 26.066406 6.90625 26.007812 6.875 25.941406 C 6.90625 26.007812 6.9375 26.066406 6.96875 26.128906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.96875 26.128906 C 6.9375 26.066406 6.90625 26.007812 6.875 25.941406 C 6.90625 26.007812 6.9375 26.066406 6.96875 26.128906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.808594 28.800781 L 8.882812 28.800781 L 8.882812 28.875 L 8.808594 28.875 Z M 8.808594 28.800781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 28.875 C 8.855469 28.851562 8.832031 28.824219 8.808594 28.800781 C 8.832031 28.824219 8.855469 28.851562 8.882812 28.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 28.875 C 8.855469 28.851562 8.832031 28.824219 8.808594 28.800781 C 8.832031 28.824219 8.855469 28.851562 8.882812 28.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.726562 27.433594 L 7.738281 27.433594 L 7.738281 27.449219 L 7.726562 27.449219 Z M 7.726562 27.433594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.738281 27.449219 C 7.738281 27.449219 7.738281 27.445312 7.734375 27.445312 C 7.738281 27.445312 7.738281 27.449219 7.738281 27.449219 M 7.734375 27.445312 C 7.734375 27.441406 7.730469 27.4375 7.726562 27.433594 C 7.730469 27.4375 7.734375 27.441406 7.734375 27.445312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.738281 27.449219 C 7.738281 27.449219 7.738281 27.445312 7.734375 27.445312 C 7.738281 27.445312 7.738281 27.449219 7.738281 27.449219 M 7.734375 27.445312 C 7.734375 27.441406 7.730469 27.4375 7.726562 27.433594 C 7.730469 27.4375 7.734375 27.441406 7.734375 27.445312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.386719 28.316406 L 8.488281 28.316406 L 8.488281 28.4375 L 8.386719 28.4375 Z M 8.386719 28.316406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.488281 28.4375 C 8.457031 28.398438 8.421875 28.359375 8.386719 28.316406 C 8.421875 28.359375 8.457031 28.398438 8.488281 28.4375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.488281 28.4375 C 8.457031 28.398438 8.421875 28.359375 8.386719 28.316406 C 8.421875 28.359375 8.457031 28.398438 8.488281 28.4375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.949219 27.75 L 8.054688 27.75 L 8.054688 27.890625 L 7.949219 27.890625 Z M 7.949219 27.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.054688 27.890625 C 8.019531 27.84375 7.984375 27.796875 7.949219 27.75 C 7.984375 27.796875 8.019531 27.84375 8.054688 27.890625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.054688 27.890625 C 8.019531 27.84375 7.984375 27.796875 7.949219 27.75 C 7.984375 27.796875 8.019531 27.84375 8.054688 27.890625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.605469 27.246094 L 7.609375 27.246094 L 7.609375 27.253906 L 7.605469 27.253906 Z M 7.605469 27.246094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.609375 27.253906 C 7.609375 27.25 7.605469 27.25 7.605469 27.25 C 7.605469 27.25 7.609375 27.25 7.609375 27.253906 M 7.605469 27.25 C 7.605469 27.246094 7.605469 27.246094 7.605469 27.246094 C 7.605469 27.246094 7.605469 27.246094 7.605469 27.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.609375 27.253906 C 7.609375 27.25 7.605469 27.25 7.605469 27.25 C 7.605469 27.25 7.609375 27.25 7.609375 27.253906 M 7.605469 27.25 C 7.605469 27.246094 7.605469 27.246094 7.605469 27.246094 C 7.605469 27.246094 7.605469 27.246094 7.605469 27.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.078125 26.347656 L 7.164062 26.347656 L 7.164062 26.507812 L 7.078125 26.507812 Z M 7.078125 26.347656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.164062 26.507812 C 7.136719 26.453125 7.105469 26.402344 7.078125 26.347656 C 7.105469 26.402344 7.136719 26.453125 7.164062 26.507812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.164062 26.507812 C 7.136719 26.453125 7.105469 26.402344 7.078125 26.347656 C 7.105469 26.402344 7.136719 26.453125 7.164062 26.507812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.289062 26.730469 L 7.390625 26.730469 L 7.390625 26.902344 L 7.289062 26.902344 Z M 7.289062 26.730469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.390625 26.902344 C 7.355469 26.847656 7.324219 26.789062 7.289062 26.730469 C 7.324219 26.789062 7.355469 26.847656 7.390625 26.902344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.390625 26.902344 C 7.355469 26.847656 7.324219 26.789062 7.289062 26.730469 C 7.324219 26.789062 7.355469 26.847656 7.390625 26.902344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.363281 11.53125 L 14 11.53125 L 14 29.9375 L 4.363281 29.9375 Z M 4.363281 11.53125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.136719 11.542969 C 13.578125 11.613281 13.042969 11.726562 12.527344 11.875 C 11.757812 12.097656 11.039062 12.410156 10.378906 12.78125 C 9.0625 13.53125 7.984375 14.539062 7.21875 15.660156 C 6.960938 16.035156 6.742188 16.421875 6.558594 16.8125 C 6.28125 17.402344 6.085938 18.003906 5.984375 18.605469 C 5.941406 18.84375 5.910156 19.078125 5.878906 19.308594 C 5.882812 19.304688 5.882812 19.300781 5.882812 19.296875 C 5.882812 19.300781 5.882812 19.304688 5.878906 19.308594 C 5.882812 19.304688 5.882812 19.300781 5.882812 19.296875 C 5.882812 19.300781 5.882812 19.304688 5.878906 19.308594 C 5.871094 19.386719 5.867188 19.460938 5.859375 19.539062 C 5.84375 19.6875 5.824219 19.839844 5.816406 19.984375 C 5.808594 20.074219 5.804688 20.164062 5.800781 20.253906 C 5.792969 20.382812 5.785156 20.515625 5.78125 20.640625 C 5.78125 20.648438 5.78125 20.652344 5.78125 20.65625 C 5.78125 20.652344 5.78125 20.648438 5.78125 20.640625 C 5.78125 20.671875 5.78125 20.703125 5.78125 20.734375 C 5.78125 20.761719 5.78125 20.789062 5.78125 20.816406 C 5.78125 20.84375 5.78125 20.871094 5.78125 20.898438 C 5.78125 20.902344 5.78125 20.90625 5.78125 20.910156 C 5.78125 20.910156 5.78125 20.90625 5.78125 20.902344 C 5.78125 20.90625 5.78125 20.910156 5.78125 20.910156 C 5.78125 20.917969 5.78125 20.921875 5.78125 20.925781 C 5.78125 20.980469 5.78125 21.039062 5.78125 21.097656 C 5.78125 21.105469 5.78125 21.113281 5.78125 21.121094 C 5.78125 21.171875 5.78125 21.222656 5.785156 21.273438 C 5.785156 21.269531 5.785156 21.265625 5.78125 21.261719 C 5.785156 21.265625 5.785156 21.269531 5.785156 21.273438 C 5.785156 21.367188 5.792969 21.457031 5.796875 21.546875 C 5.800781 21.660156 5.804688 21.773438 5.8125 21.882812 C 5.816406 21.925781 5.820312 21.96875 5.824219 22.011719 C 5.820312 21.96875 5.816406 21.925781 5.8125 21.882812 C 5.816406 21.925781 5.820312 21.96875 5.824219 22.011719 C 5.832031 22.058594 5.835938 22.105469 5.839844 22.152344 C 5.851562 22.257812 5.859375 22.363281 5.871094 22.464844 C 5.871094 22.46875 5.871094 22.46875 5.871094 22.46875 C 5.871094 22.46875 5.871094 22.46875 5.871094 22.464844 C 5.871094 22.46875 5.871094 22.46875 5.871094 22.46875 C 5.871094 22.46875 5.871094 22.46875 5.871094 22.464844 C 5.871094 22.46875 5.871094 22.46875 5.871094 22.46875 C 5.875 22.480469 5.875 22.488281 5.875 22.5 C 5.886719 22.578125 5.898438 22.652344 5.910156 22.730469 C 5.898438 22.652344 5.886719 22.578125 5.875 22.5 C 5.886719 22.578125 5.898438 22.652344 5.910156 22.730469 C 5.925781 22.832031 5.9375 22.933594 5.957031 23.035156 C 5.972656 23.121094 5.988281 23.203125 6.003906 23.289062 C 6.023438 23.382812 6.042969 23.480469 6.0625 23.574219 C 6.082031 23.65625 6.101562 23.738281 6.125 23.820312 C 6.144531 23.910156 6.167969 24.003906 6.191406 24.09375 C 6.214844 24.171875 6.238281 24.25 6.261719 24.324219 C 6.285156 24.414062 6.3125 24.503906 6.339844 24.589844 C 6.351562 24.628906 6.367188 24.664062 6.378906 24.703125 C 6.390625 24.738281 6.402344 24.773438 6.417969 24.8125 C 6.402344 24.773438 6.390625 24.738281 6.378906 24.703125 C 6.390625 24.738281 6.402344 24.773438 6.417969 24.8125 C 6.425781 24.839844 6.4375 24.867188 6.445312 24.894531 C 6.464844 24.953125 6.484375 25.007812 6.503906 25.0625 C 6.484375 25.007812 6.464844 24.953125 6.445312 24.894531 C 6.464844 24.953125 6.484375 25.007812 6.503906 25.0625 C 6.53125 25.136719 6.5625 25.207031 6.589844 25.277344 C 6.605469 25.320312 6.621094 25.363281 6.640625 25.402344 C 6.652344 25.441406 6.667969 25.476562 6.683594 25.511719 C 6.667969 25.476562 6.652344 25.441406 6.640625 25.402344 C 6.652344 25.441406 6.667969 25.476562 6.683594 25.511719 C 6.6875 25.519531 6.6875 25.523438 6.691406 25.53125 C 6.6875 25.523438 6.6875 25.519531 6.683594 25.511719 C 6.6875 25.519531 6.6875 25.523438 6.691406 25.53125 C 6.71875 25.59375 6.746094 25.652344 6.773438 25.714844 C 6.804688 25.789062 6.835938 25.859375 6.871094 25.929688 C 6.835938 25.859375 6.804688 25.789062 6.773438 25.714844 C 6.804688 25.789062 6.835938 25.859375 6.871094 25.929688 C 6.871094 25.933594 6.875 25.9375 6.875 25.941406 C 6.90625 26.007812 6.9375 26.066406 6.96875 26.128906 C 6.96875 26.132812 6.96875 26.132812 6.972656 26.132812 C 6.96875 26.132812 6.96875 26.132812 6.96875 26.128906 C 6.96875 26.132812 6.96875 26.132812 6.972656 26.132812 C 7.007812 26.207031 7.042969 26.277344 7.078125 26.347656 C 7.105469 26.402344 7.136719 26.453125 7.164062 26.507812 C 7.167969 26.515625 7.171875 26.523438 7.175781 26.53125 C 7.171875 26.523438 7.167969 26.515625 7.164062 26.507812 C 7.167969 26.515625 7.171875 26.523438 7.175781 26.53125 C 7.179688 26.53125 7.179688 26.535156 7.183594 26.539062 C 7.21875 26.605469 7.253906 26.667969 7.289062 26.730469 C 7.253906 26.667969 7.21875 26.605469 7.183594 26.539062 C 7.21875 26.605469 7.253906 26.667969 7.289062 26.730469 C 7.324219 26.789062 7.355469 26.847656 7.390625 26.902344 C 7.429688 26.96875 7.46875 27.03125 7.507812 27.09375 C 7.539062 27.144531 7.570312 27.195312 7.605469 27.246094 C 7.570312 27.195312 7.539062 27.144531 7.507812 27.09375 C 7.539062 27.144531 7.570312 27.195312 7.605469 27.246094 C 7.605469 27.246094 7.605469 27.246094 7.605469 27.25 C 7.605469 27.25 7.609375 27.25 7.609375 27.253906 C 7.632812 27.292969 7.660156 27.332031 7.683594 27.367188 C 7.660156 27.332031 7.632812 27.292969 7.609375 27.253906 C 7.632812 27.292969 7.660156 27.332031 7.683594 27.367188 C 7.699219 27.390625 7.710938 27.410156 7.726562 27.433594 C 7.730469 27.4375 7.734375 27.441406 7.734375 27.445312 C 7.738281 27.445312 7.738281 27.449219 7.738281 27.449219 C 7.769531 27.492188 7.800781 27.539062 7.832031 27.582031 C 7.800781 27.539062 7.769531 27.492188 7.738281 27.449219 C 7.769531 27.492188 7.800781 27.539062 7.832031 27.582031 C 7.871094 27.640625 7.910156 27.695312 7.949219 27.75 C 7.984375 27.796875 8.019531 27.84375 8.054688 27.890625 C 8.078125 27.925781 8.105469 27.960938 8.132812 27.996094 C 8.105469 27.960938 8.078125 27.925781 8.054688 27.890625 C 8.078125 27.925781 8.105469 27.960938 8.132812 27.996094 C 8.144531 28.011719 8.15625 28.027344 8.167969 28.042969 C 8.203125 28.089844 8.238281 28.132812 8.273438 28.175781 C 8.277344 28.179688 8.28125 28.1875 8.285156 28.191406 C 8.320312 28.234375 8.355469 28.277344 8.386719 28.316406 C 8.355469 28.277344 8.320312 28.234375 8.285156 28.191406 C 8.320312 28.234375 8.355469 28.277344 8.386719 28.316406 C 8.421875 28.359375 8.457031 28.398438 8.488281 28.4375 C 8.527344 28.480469 8.566406 28.527344 8.601562 28.570312 C 8.601562 28.570312 8.601562 28.570312 8.605469 28.570312 C 8.636719 28.609375 8.667969 28.644531 8.699219 28.679688 C 8.667969 28.644531 8.636719 28.609375 8.605469 28.570312 C 8.636719 28.609375 8.667969 28.644531 8.699219 28.679688 C 8.699219 28.679688 8.703125 28.683594 8.703125 28.683594 C 8.703125 28.683594 8.699219 28.679688 8.699219 28.679688 C 8.699219 28.679688 8.703125 28.683594 8.703125 28.683594 C 8.738281 28.722656 8.773438 28.761719 8.808594 28.800781 C 8.832031 28.824219 8.855469 28.851562 8.882812 28.875 C 8.886719 28.882812 8.894531 28.890625 8.902344 28.898438 C 8.894531 28.890625 8.886719 28.882812 8.882812 28.875 C 8.886719 28.882812 8.894531 28.890625 8.902344 28.898438 C 8.914062 28.910156 8.925781 28.921875 8.9375 28.9375 C 8.960938 28.960938 8.984375 28.984375 9.003906 29.007812 C 8.984375 28.984375 8.960938 28.960938 8.9375 28.9375 C 8.960938 28.960938 8.984375 28.984375 9.003906 29.007812 C 9.035156 29.035156 9.066406 29.066406 9.09375 29.09375 C 9.105469 29.105469 9.117188 29.117188 9.128906 29.128906 C 9.117188 29.117188 9.105469 29.105469 9.09375 29.09375 C 9.105469 29.105469 9.117188 29.117188 9.128906 29.128906 C 9.148438 29.152344 9.171875 29.171875 9.191406 29.191406 C 9.21875 29.21875 9.246094 29.246094 9.273438 29.269531 C 9.304688 29.300781 9.335938 29.328125 9.363281 29.359375 C 9.371094 29.363281 9.378906 29.371094 9.382812 29.375 C 9.378906 29.371094 9.371094 29.363281 9.363281 29.359375 C 9.371094 29.363281 9.378906 29.371094 9.382812 29.375 C 9.402344 29.394531 9.417969 29.410156 9.4375 29.425781 C 9.464844 29.453125 9.492188 29.476562 9.519531 29.5 C 9.527344 29.507812 9.535156 29.511719 9.539062 29.519531 C 9.535156 29.511719 9.527344 29.507812 9.519531 29.5 C 9.527344 29.507812 9.535156 29.511719 9.539062 29.519531 C 9.554688 29.53125 9.570312 29.546875 9.585938 29.558594 C 9.609375 29.582031 9.636719 29.601562 9.660156 29.621094 C 9.679688 29.640625 9.695312 29.65625 9.714844 29.671875 C 9.722656 29.675781 9.730469 29.683594 9.738281 29.691406 C 9.730469 29.683594 9.722656 29.675781 9.714844 29.671875 C 9.722656 29.675781 9.730469 29.683594 9.738281 29.691406 C 9.75 29.703125 9.765625 29.714844 9.777344 29.722656 C 9.785156 29.730469 9.792969 29.738281 9.800781 29.742188 C 9.792969 29.738281 9.785156 29.730469 9.777344 29.722656 C 9.785156 29.730469 9.792969 29.738281 9.800781 29.742188 C 9.808594 29.75 9.816406 29.757812 9.824219 29.761719 C 9.835938 29.769531 9.84375 29.777344 9.855469 29.785156 C 9.84375 29.777344 9.835938 29.769531 9.824219 29.761719 C 9.832031 29.769531 9.84375 29.777344 9.855469 29.785156 C 9.863281 29.792969 9.871094 29.800781 9.878906 29.808594 C 9.882812 29.808594 9.882812 29.8125 9.882812 29.8125 C 9.882812 29.8125 9.882812 29.808594 9.878906 29.808594 C 9.882812 29.808594 9.882812 29.8125 9.882812 29.8125 C 9.882812 29.8125 9.886719 29.8125 9.886719 29.8125 C 9.894531 29.820312 9.90625 29.828125 9.914062 29.835938 C 9.933594 29.851562 9.949219 29.863281 9.960938 29.875 C 9.96875 29.882812 9.972656 29.886719 9.976562 29.890625 L 9.992188 29.902344 L 9.996094 29.910156 C 9.96875 29.898438 4.410156 27.355469 4.410156 21.089844 C 4.410156 20.476562 4.464844 19.828125 4.582031 19.140625 C 5.804688 11.96875 12.265625 11.535156 13.804688 11.535156 C 14.019531 11.535156 14.136719 11.542969 14.136719 11.542969 M 10.378906 12.78125 C 11.039062 12.410156 11.757812 12.097656 12.527344 11.875 C 11.757812 12.097656 11.039062 12.410156 10.378906 12.78125 M 10.378906 12.78125 C 11.039062 12.410156 11.757812 12.097656 12.527344 11.875 C 11.757812 12.097656 11.039062 12.410156 10.378906 12.78125 M 9.976562 29.890625 L 9.992188 29.902344 L 9.976562 29.890625 M 9.976562 29.890625 L 9.992188 29.902344 L 9.976562 29.890625 M 9.960938 29.875 C 9.96875 29.878906 9.972656 29.886719 9.976562 29.890625 C 9.972656 29.886719 9.96875 29.882812 9.960938 29.875 M 9.660156 29.621094 C 9.636719 29.601562 9.609375 29.582031 9.585938 29.558594 C 9.609375 29.582031 9.636719 29.601562 9.660156 29.621094 M 9.519531 29.5 C 9.492188 29.476562 9.464844 29.453125 9.4375 29.425781 C 9.464844 29.453125 9.492188 29.476562 9.519531 29.5 M 9.363281 29.359375 C 9.335938 29.328125 9.304688 29.300781 9.273438 29.269531 C 9.304688 29.300781 9.335938 29.328125 9.363281 29.359375 M 9.191406 29.191406 C 9.21875 29.21875 9.246094 29.246094 9.273438 29.269531 C 9.246094 29.246094 9.21875 29.21875 9.191406 29.191406 M 8.167969 28.042969 C 8.203125 28.089844 8.238281 28.132812 8.273438 28.175781 C 8.238281 28.132812 8.203125 28.089844 8.167969 28.042969 M 7.949219 27.75 C 7.910156 27.695312 7.871094 27.640625 7.832031 27.582031 C 7.871094 27.640625 7.910156 27.695312 7.949219 27.75 M 7.199219 15.691406 C 7.203125 15.683594 7.210938 15.671875 7.21875 15.660156 C 7.210938 15.671875 7.203125 15.683594 7.199219 15.691406 C 7.203125 15.683594 7.210938 15.671875 7.21875 15.660156 C 7.210938 15.671875 7.203125 15.683594 7.199219 15.691406 C 6.949219 16.054688 6.734375 16.429688 6.558594 16.8125 C 6.734375 16.429688 6.949219 16.054688 7.199219 15.691406 M 7.078125 26.347656 C 7.042969 26.277344 7.007812 26.207031 6.972656 26.132812 C 7.007812 26.207031 7.042969 26.277344 7.078125 26.347656 M 6.339844 24.589844 C 6.3125 24.503906 6.285156 24.414062 6.261719 24.324219 C 6.285156 24.414062 6.3125 24.503906 6.339844 24.589844 M 6.191406 24.09375 C 6.214844 24.171875 6.238281 24.25 6.261719 24.324219 C 6.238281 24.25 6.214844 24.171875 6.191406 24.09375 M 6.0625 23.574219 C 6.082031 23.65625 6.101562 23.738281 6.125 23.820312 C 6.101562 23.738281 6.082031 23.65625 6.0625 23.574219 M 6.0625 23.574219 C 6.042969 23.480469 6.023438 23.382812 6.003906 23.289062 C 6.023438 23.382812 6.042969 23.480469 6.0625 23.574219 M 5.957031 23.035156 C 5.9375 22.933594 5.925781 22.832031 5.910156 22.730469 C 5.925781 22.832031 5.9375 22.933594 5.957031 23.035156 M 5.816406 19.984375 C 5.824219 19.839844 5.84375 19.6875 5.859375 19.539062 C 5.84375 19.6875 5.824219 19.839844 5.816406 19.984375 M 5.816406 19.984375 C 5.824219 19.839844 5.84375 19.6875 5.859375 19.539062 C 5.84375 19.6875 5.824219 19.839844 5.816406 19.984375 M 5.816406 19.984375 C 5.808594 20.074219 5.804688 20.164062 5.800781 20.253906 C 5.804688 20.164062 5.808594 20.074219 5.816406 19.984375 M 5.8125 21.882812 C 5.804688 21.773438 5.800781 21.660156 5.796875 21.546875 C 5.800781 21.660156 5.804688 21.773438 5.8125 21.882812 M 5.78125 20.640625 C 5.785156 20.515625 5.792969 20.382812 5.800781 20.253906 C 5.792969 20.382812 5.785156 20.515625 5.78125 20.640625 M 5.78125 20.640625 C 5.785156 20.515625 5.792969 20.382812 5.800781 20.253906 C 5.792969 20.382812 5.785156 20.515625 5.78125 20.640625 M 5.785156 21.273438 C 5.785156 21.367188 5.792969 21.457031 5.796875 21.546875 C 5.792969 21.457031 5.785156 21.367188 5.785156 21.273438 M 5.78125 21.261719 C 5.78125 21.261719 5.78125 21.257812 5.78125 21.257812 C 5.78125 21.257812 5.78125 21.261719 5.78125 21.261719 M 5.78125 21.242188 C 5.78125 21.203125 5.78125 21.160156 5.78125 21.121094 C 5.78125 21.160156 5.78125 21.203125 5.78125 21.242188 M 5.78125 21.121094 L 5.78125 21.121094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.261719 28.15625 L 8.398438 28.15625 L 8.398438 28.363281 L 8.261719 28.363281 Z M 8.261719 28.15625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.386719 28.316406 C 8.355469 28.277344 8.320312 28.234375 8.285156 28.191406 C 8.320312 28.234375 8.355469 28.277344 8.386719 28.316406 M 8.285156 28.191406 C 8.28125 28.1875 8.277344 28.179688 8.273438 28.175781 C 8.277344 28.179688 8.28125 28.1875 8.285156 28.191406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 28 L 8.191406 28 L 8.191406 28.089844 L 8 28.089844 Z M 8 28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.167969 28.042969 C 8.15625 28.027344 8.144531 28.011719 8.132812 27.996094 C 8.144531 28.011719 8.15625 28.027344 8.167969 28.042969 M 8.132812 27.996094 C 8.105469 27.960938 8.078125 27.925781 8.054688 27.890625 C 8.078125 27.925781 8.105469 27.960938 8.132812 27.996094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.363281 11.53125 L 14 11.53125 L 14 29.9375 L 4.363281 29.9375 Z M 4.363281 11.53125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.136719 11.542969 C 14.136719 11.542969 14.019531 11.535156 13.804688 11.535156 C 14.019531 11.535156 14.136719 11.542969 14.136719 11.542969 M 9.996094 29.910156 C 9.96875 29.898438 4.410156 27.359375 4.410156 21.089844 C 4.410156 27.355469 9.96875 29.898438 9.996094 29.910156"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.207031 24.324219 L 6.347656 24.324219 L 6.347656 24.597656 L 6.207031 24.597656 Z M 6.207031 24.324219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.339844 24.589844 C 6.3125 24.503906 6.285156 24.414062 6.261719 24.324219 C 6.285156 24.414062 6.3125 24.503906 6.339844 24.589844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.414062 25 L 6.550781 25 L 6.550781 25.078125 L 6.414062 25.078125 Z M 6.414062 25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.503906 25.0625 C 6.484375 25.007812 6.464844 24.953125 6.445312 24.894531 C 6.464844 24.953125 6.484375 25.007812 6.503906 25.0625 M 6.445312 24.894531 C 6.4375 24.867188 6.425781 24.839844 6.417969 24.8125 C 6.425781 24.839844 6.4375 24.867188 6.445312 24.894531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ei"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.167969 26.515625 L 7.304688 26.515625 L 7.304688 26.789062 L 7.167969 26.789062 Z M 7.167969 26.515625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ej"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.289062 26.730469 C 7.253906 26.667969 7.21875 26.605469 7.183594 26.539062 C 7.21875 26.605469 7.253906 26.667969 7.289062 26.730469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ek"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.003906 23.230469 L 6.070312 23.230469 L 6.070312 23.640625 L 6.003906 23.640625 Z M 6.003906 23.230469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "el"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.0625 23.574219 C 6.042969 23.480469 6.023438 23.382812 6.003906 23.289062 C 6.023438 23.382812 6.042969 23.480469 6.0625 23.574219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 26.105469 L 7.097656 26.105469 L 7.097656 26.378906 L 7 26.378906 Z M 7 26.105469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "en"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.078125 26.347656 C 7.042969 26.277344 7.007812 26.207031 6.972656 26.132812 C 7.007812 26.207031 7.042969 26.277344 7.078125 26.347656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.425781 29.386719 L 9.5625 29.386719 L 9.5625 29.523438 L 9.425781 29.523438 Z M 9.425781 29.386719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ep"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.519531 29.5 C 9.492188 29.476562 9.464844 29.453125 9.4375 29.425781 C 9.464844 29.453125 9.492188 29.476562 9.519531 29.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.082031 29.046875 L 9.21875 29.046875 L 9.21875 29.25 L 9.082031 29.25 Z M 9.082031 29.046875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "er"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.191406 29.191406 C 9.171875 29.171875 9.148438 29.152344 9.128906 29.128906 C 9.148438 29.152344 9.171875 29.171875 9.191406 29.191406 M 9.128906 29.128906 C 9.117188 29.117188 9.105469 29.105469 9.09375 29.09375 C 9.105469 29.105469 9.117188 29.117188 9.128906 29.128906"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "es"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.3125 12 L 12.574219 12 L 12.574219 12.832031 L 10.3125 12.832031 Z M 10.3125 12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "et"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.527344 11.875 C 11.757812 12.097656 11.039062 12.410156 10.378906 12.78125 C 11.039062 12.410156 11.757812 12.097656 12.527344 11.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 29 L 9.015625 29 L 9.015625 29.046875 L 9 29.046875 Z M 9 29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ev"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.003906 29.007812 C 8.984375 28.984375 8.960938 28.960938 8.9375 28.9375 C 8.960938 28.960938 8.984375 28.984375 9.003906 29.007812 M 8.9375 28.9375 C 8.925781 28.921875 8.914062 28.910156 8.902344 28.898438 C 8.914062 28.910156 8.925781 28.921875 8.9375 28.9375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ew"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.550781 16 L 7 16 L 7 16.867188 L 6.550781 16.867188 Z M 6.550781 16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ex"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.199219 15.691406 C 6.949219 16.054688 6.734375 16.429688 6.558594 16.8125 C 6.734375 16.429688 6.949219 16.054688 7.199219 15.691406"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ey"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.21875 29.25 L 9.425781 29.25 L 9.425781 29.386719 L 9.21875 29.386719 Z M 9.21875 29.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ez"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.363281 29.359375 C 9.335938 29.328125 9.304688 29.300781 9.273438 29.269531 C 9.304688 29.300781 9.335938 29.328125 9.363281 29.359375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.492188 29.457031 L 9.628906 29.457031 L 9.628906 29.59375 L 9.492188 29.59375 Z M 9.492188 29.457031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.585938 29.558594 C 9.570312 29.546875 9.554688 29.53125 9.539062 29.519531 C 9.554688 29.53125 9.570312 29.546875 9.585938 29.558594 M 9.539062 29.519531 C 9.535156 29.511719 9.527344 29.507812 9.519531 29.5 C 9.527344 29.507812 9.535156 29.511719 9.539062 29.519531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.355469 29.320312 L 9.492188 29.320312 L 9.492188 29.457031 L 9.355469 29.457031 Z M 9.355469 29.320312"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.4375 29.425781 C 9.417969 29.410156 9.402344 29.394531 9.382812 29.375 C 9.402344 29.394531 9.417969 29.410156 9.4375 29.425781 M 9.382812 29.375 C 9.378906 29.371094 9.371094 29.363281 9.363281 29.359375 C 9.371094 29.363281 9.378906 29.371094 9.382812 29.375"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.152344 29.183594 L 9.289062 29.183594 L 9.289062 29.320312 L 9.152344 29.320312 Z M 9.152344 29.183594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.273438 29.269531 C 9.246094 29.246094 9.21875 29.21875 9.191406 29.191406 C 9.21875 29.21875 9.246094 29.246094 9.273438 29.269531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.140625 24.050781 L 6.277344 24.050781 L 6.277344 24.394531 L 6.140625 24.394531 Z M 6.140625 24.050781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.261719 24.324219 C 6.238281 24.25 6.214844 24.171875 6.191406 24.09375 C 6.214844 24.171875 6.238281 24.25 6.261719 24.324219"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.125 28.019531 L 8.328125 28.019531 L 8.328125 28.226562 L 8.125 28.226562 Z M 8.125 28.019531"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.273438 28.175781 C 8.238281 28.132812 8.203125 28.089844 8.167969 28.042969 C 8.203125 28.089844 8.238281 28.132812 8.273438 28.175781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.441406 27.0625 L 7.644531 27.0625 L 7.644531 27.265625 L 7.441406 27.265625 Z M 7.441406 27.0625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.609375 27.253906 C 7.609375 27.25 7.605469 27.25 7.605469 27.25 C 7.605469 27.25 7.609375 27.25 7.609375 27.253906 M 7.605469 27.25 C 7.605469 27.246094 7.605469 27.246094 7.605469 27.246094 C 7.605469 27.246094 7.605469 27.246094 7.605469 27.25 M 7.605469 27.246094 C 7.570312 27.195312 7.539062 27.144531 7.507812 27.09375 C 7.539062 27.144531 7.570312 27.195312 7.605469 27.246094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.03125 26.308594 L 7.234375 26.308594 L 7.234375 26.582031 L 7.03125 26.582031 Z M 7.03125 26.308594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.175781 26.53125 C 7.171875 26.523438 7.167969 26.515625 7.164062 26.507812 C 7.167969 26.515625 7.171875 26.523438 7.175781 26.53125 M 7.164062 26.507812 C 7.136719 26.453125 7.105469 26.402344 7.078125 26.347656 C 7.105469 26.402344 7.136719 26.453125 7.164062 26.507812"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.363281 11.53125 L 14.136719 11.53125 L 14.136719 29.910156 L 4.363281 29.910156 Z M 4.363281 11.53125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.976562 29.890625 C 9.972656 29.886719 9.96875 29.882812 9.960938 29.875 C 9.949219 29.863281 9.933594 29.851562 9.914062 29.835938 C 9.902344 29.828125 9.894531 29.820312 9.878906 29.808594 C 9.863281 29.792969 9.84375 29.777344 9.824219 29.761719 C 9.808594 29.75 9.792969 29.738281 9.777344 29.722656 C 9.757812 29.707031 9.738281 29.691406 9.714844 29.671875 C 9.695312 29.65625 9.679688 29.640625 9.660156 29.621094 C 9.636719 29.601562 9.609375 29.582031 9.585938 29.558594 C 9.5625 29.539062 9.542969 29.519531 9.519531 29.5 C 9.492188 29.476562 9.464844 29.453125 9.4375 29.425781 C 9.414062 29.402344 9.390625 29.382812 9.363281 29.359375 C 9.335938 29.328125 9.304688 29.300781 9.273438 29.269531 C 9.246094 29.246094 9.21875 29.21875 9.191406 29.191406 C 9.160156 29.160156 9.125 29.128906 9.09375 29.09375 C 9.066406 29.066406 9.035156 29.035156 9.003906 29.007812 C 8.972656 28.972656 8.9375 28.933594 8.902344 28.898438 C 8.871094 28.863281 8.839844 28.832031 8.808594 28.800781 C 8.773438 28.761719 8.734375 28.71875 8.699219 28.679688 C 8.667969 28.640625 8.636719 28.605469 8.601562 28.570312 C 8.566406 28.527344 8.527344 28.480469 8.488281 28.4375 C 8.457031 28.398438 8.421875 28.359375 8.386719 28.316406 C 8.351562 28.269531 8.3125 28.222656 8.273438 28.175781 C 8.238281 28.132812 8.203125 28.089844 8.167969 28.042969 C 8.128906 27.992188 8.09375 27.941406 8.054688 27.890625 C 8.019531 27.84375 7.984375 27.796875 7.949219 27.75 C 7.910156 27.695312 7.871094 27.640625 7.832031 27.582031 C 7.796875 27.53125 7.761719 27.484375 7.726562 27.433594 C 7.6875 27.375 7.648438 27.3125 7.609375 27.253906 C 7.574219 27.199219 7.539062 27.148438 7.507812 27.09375 C 7.46875 27.03125 7.429688 26.96875 7.390625 26.902344 C 7.355469 26.847656 7.324219 26.789062 7.289062 26.730469 C 7.25 26.664062 7.214844 26.597656 7.175781 26.53125 C 7.144531 26.46875 7.109375 26.410156 7.078125 26.347656 C 7.042969 26.277344 7.007812 26.207031 6.972656 26.132812 C 6.9375 26.070312 6.90625 26.007812 6.875 25.941406 C 6.839844 25.867188 6.808594 25.792969 6.773438 25.714844 C 6.742188 25.648438 6.714844 25.582031 6.683594 25.511719 C 6.652344 25.4375 6.621094 25.355469 6.589844 25.277344 C 6.5625 25.207031 6.53125 25.136719 6.503906 25.0625 C 6.472656 24.980469 6.445312 24.894531 6.417969 24.8125 C 6.390625 24.738281 6.363281 24.664062 6.339844 24.589844 C 6.3125 24.503906 6.285156 24.414062 6.261719 24.324219 C 6.238281 24.25 6.214844 24.171875 6.191406 24.09375 C 6.167969 24.003906 6.144531 23.910156 6.125 23.820312 C 6.101562 23.738281 6.082031 23.65625 6.0625 23.574219 C 6.042969 23.480469 6.023438 23.382812 6.003906 23.289062 C 5.988281 23.203125 5.972656 23.121094 5.957031 23.035156 C 5.9375 22.933594 5.925781 22.832031 5.910156 22.730469 C 5.898438 22.644531 5.882812 22.558594 5.871094 22.46875 C 5.859375 22.367188 5.851562 22.257812 5.839844 22.152344 C 5.832031 22.0625 5.820312 21.976562 5.8125 21.882812 C 5.804688 21.773438 5.800781 21.660156 5.796875 21.546875 C 5.792969 21.457031 5.785156 21.367188 5.785156 21.273438 C 5.78125 21.15625 5.78125 21.03125 5.78125 20.910156 C 5.78125 20.820312 5.78125 20.734375 5.78125 20.640625 C 5.785156 20.515625 5.792969 20.382812 5.800781 20.253906 C 5.804688 20.164062 5.808594 20.074219 5.816406 19.984375 C 5.824219 19.839844 5.84375 19.6875 5.859375 19.539062 C 5.867188 19.460938 5.871094 19.386719 5.878906 19.308594 C 5.910156 19.078125 5.941406 18.84375 5.984375 18.605469 C 6.085938 18.003906 6.28125 17.402344 6.558594 16.8125 C 6.742188 16.421875 6.960938 16.035156 7.21875 15.660156 C 7.988281 14.539062 9.0625 13.53125 10.378906 12.78125 C 11.039062 12.410156 11.757812 12.097656 12.527344 11.875 C 13.042969 11.726562 13.578125 11.613281 14.136719 11.542969 C 14.136719 11.542969 5.972656 10.984375 4.582031 19.140625 C 3.265625 26.851562 9.996094 29.910156 9.996094 29.910156 L 9.992188 29.902344 Z M 9.976562 29.890625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.976562 29.890625 C 9.972656 29.886719 9.96875 29.882812 9.960938 29.875 C 9.949219 29.863281 9.933594 29.851562 9.914062 29.835938 C 9.902344 29.828125 9.894531 29.820312 9.878906 29.808594 C 9.863281 29.792969 9.84375 29.777344 9.824219 29.761719 C 9.808594 29.75 9.792969 29.738281 9.777344 29.722656 C 9.757812 29.707031 9.738281 29.691406 9.714844 29.671875 C 9.695312 29.65625 9.679688 29.640625 9.660156 29.621094 C 9.636719 29.601562 9.609375 29.582031 9.585938 29.558594 C 9.5625 29.539062 9.542969 29.519531 9.519531 29.5 C 9.492188 29.476562 9.464844 29.453125 9.4375 29.425781 C 9.414062 29.402344 9.390625 29.382812 9.363281 29.359375 C 9.335938 29.328125 9.304688 29.300781 9.273438 29.269531 C 9.246094 29.246094 9.21875 29.21875 9.191406 29.191406 C 9.160156 29.160156 9.125 29.128906 9.09375 29.09375 C 9.066406 29.066406 9.035156 29.035156 9.003906 29.007812 C 8.972656 28.972656 8.9375 28.933594 8.902344 28.898438 C 8.871094 28.863281 8.839844 28.832031 8.808594 28.800781 C 8.773438 28.761719 8.734375 28.71875 8.699219 28.679688 C 8.667969 28.640625 8.636719 28.605469 8.601562 28.570312 C 8.566406 28.527344 8.527344 28.480469 8.488281 28.4375 C 8.457031 28.398438 8.421875 28.359375 8.386719 28.316406 C 8.351562 28.269531 8.3125 28.222656 8.273438 28.175781 C 8.238281 28.132812 8.203125 28.089844 8.167969 28.042969 C 8.128906 27.992188 8.09375 27.941406 8.054688 27.890625 C 8.019531 27.84375 7.984375 27.796875 7.949219 27.75 C 7.910156 27.695312 7.871094 27.640625 7.832031 27.582031 C 7.796875 27.53125 7.761719 27.484375 7.726562 27.433594 C 7.6875 27.375 7.648438 27.3125 7.609375 27.253906 C 7.574219 27.199219 7.539062 27.148438 7.507812 27.09375 C 7.46875 27.03125 7.429688 26.96875 7.390625 26.902344 C 7.355469 26.847656 7.324219 26.789062 7.289062 26.730469 C 7.25 26.664062 7.214844 26.597656 7.175781 26.53125 C 7.144531 26.46875 7.109375 26.410156 7.078125 26.347656 C 7.042969 26.277344 7.007812 26.207031 6.972656 26.132812 C 6.9375 26.070312 6.90625 26.007812 6.875 25.941406 C 6.839844 25.867188 6.808594 25.792969 6.773438 25.714844 C 6.742188 25.648438 6.714844 25.582031 6.683594 25.511719 C 6.652344 25.4375 6.621094 25.355469 6.589844 25.277344 C 6.5625 25.207031 6.53125 25.136719 6.503906 25.0625 C 6.472656 24.980469 6.445312 24.894531 6.417969 24.8125 C 6.390625 24.738281 6.363281 24.664062 6.339844 24.589844 C 6.3125 24.503906 6.285156 24.414062 6.261719 24.324219 C 6.238281 24.25 6.214844 24.171875 6.191406 24.09375 C 6.167969 24.003906 6.144531 23.910156 6.125 23.820312 C 6.101562 23.738281 6.082031 23.65625 6.0625 23.574219 C 6.042969 23.480469 6.023438 23.382812 6.003906 23.289062 C 5.988281 23.203125 5.972656 23.121094 5.957031 23.035156 C 5.9375 22.933594 5.925781 22.832031 5.910156 22.730469 C 5.898438 22.644531 5.882812 22.558594 5.871094 22.46875 C 5.859375 22.367188 5.851562 22.257812 5.839844 22.152344 C 5.832031 22.0625 5.820312 21.976562 5.8125 21.882812 C 5.804688 21.773438 5.800781 21.660156 5.796875 21.546875 C 5.792969 21.457031 5.785156 21.367188 5.785156 21.273438 C 5.78125 21.15625 5.78125 21.03125 5.78125 20.910156 C 5.78125 20.820312 5.78125 20.734375 5.78125 20.640625 C 5.785156 20.515625 5.792969 20.382812 5.800781 20.253906 C 5.804688 20.164062 5.808594 20.074219 5.816406 19.984375 C 5.824219 19.839844 5.84375 19.6875 5.859375 19.539062 C 5.867188 19.460938 5.871094 19.386719 5.878906 19.308594 C 5.910156 19.078125 5.941406 18.84375 5.984375 18.605469 C 6.085938 18.003906 6.28125 17.402344 6.558594 16.8125 C 6.742188 16.421875 6.960938 16.035156 7.21875 15.660156 C 7.988281 14.539062 9.0625 13.53125 10.378906 12.78125 C 11.039062 12.410156 11.757812 12.097656 12.527344 11.875 C 13.042969 11.726562 13.578125 11.613281 14.136719 11.542969 C 14.136719 11.542969 5.972656 10.984375 4.582031 19.140625 C 3.265625 26.851562 9.996094 29.910156 9.996094 29.910156 L 9.992188 29.902344 L 9.976562 29.890625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.859,
    gradientTransform: "rotate(-45 27.51 -1.08) scale(16.62609)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0,
    x2: 0.976,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    id: "A",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40B8D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40B8D",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40B8D",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D50B8D",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D50A8D",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60A8C",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60A8C",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70A8C",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D80A8C",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8098C",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9098C",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9098C",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA098C",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA098C",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB098C",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB098C",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC098C",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC088C",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD088C",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD088D",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD088D",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE088D",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF088D",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF088D",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0078D",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0078C",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1078C",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1078C",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2068C",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2068C",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3068C",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4068C",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4068C",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5058C",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5058C",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6058C",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    gradientTransform: "rotate(-45 45.687 -8.609) scale(16.62609)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0,
    x2: 0.168,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    id: "F",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513190",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513190",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523190",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523190",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533190",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533190",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543190",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553190",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553190",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563090",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563090",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573090",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573090",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573090",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58308F",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582F8F",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592F8F",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592F8F",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F8F",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F8F",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F8F",
    offset: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2F8F",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2F90",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2F90",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D2F90",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D2E90",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E90",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E90",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2E90",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602E90",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602E90",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602E90",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612D90",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612D90",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622D8F",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622D8F",
    offset: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632D8F",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632D8F",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642C8F",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642C8F",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#652C8F",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C8F",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C8F",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C8F",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672C8F",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672C8F",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692C90",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2C90",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.545,
    gradientTransform: "rotate(-45 44.648 -8.179) scale(16.62609)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0,
    x2: 0.562,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    id: "S",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41A8E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41A8E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41A8E",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51A8E",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51A8E",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A61A8E",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.188,
    gradientTransform: "rotate(-45 35.595 -4.428) scale(16.62609)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0,
    x2: 1.172,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    id: "aJ",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513190",
    offset: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523190",
    offset: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533190",
    offset: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543190",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543190",
    offset: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553190",
    offset: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563090",
    offset: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573090",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582F90",
    offset: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592F8F",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F8F",
    offset: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2F8F",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D2E90",
    offset: 0.199
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E90",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2E90",
    offset: 0.207
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2E90",
    offset: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602E90",
    offset: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612E90",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622D90",
    offset: 0.223
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632D8F",
    offset: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632C8F",
    offset: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642C8F",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#652C8F",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C8F",
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672C90",
    offset: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692C90",
    offset: 0.254
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692C90",
    offset: 0.258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2C90",
    offset: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B2B90",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2B90",
    offset: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2A90",
    offset: 0.273
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2A90",
    offset: 0.277
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2A8F",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F2A8F",
    offset: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70298F",
    offset: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71298F",
    offset: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72298F",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72298F",
    offset: 0.301
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73298F",
    offset: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#742990",
    offset: 0.309
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#752890",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#762890",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76288F",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77278F",
    offset: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78278F",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79278F",
    offset: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A278F",
    offset: 0.336
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B278F",
    offset: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C268F",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C268F",
    offset: 0.352
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E268F",
    offset: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F268F",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80258F",
    offset: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80258F",
    offset: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81258F",
    offset: 0.371
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82258F",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83248F",
    offset: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83248F",
    offset: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84238F",
    offset: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85238F",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86238F",
    offset: 0.395
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87238F",
    offset: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88238F",
    offset: 0.402
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89238F",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89228F",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A228F",
    offset: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B228F",
    offset: 0.418
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C228F",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C218F",
    offset: 0.426
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D218F",
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E218F",
    offset: 0.434
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F218E",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90208E",
    offset: 0.441
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90208E",
    offset: 0.445
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91208E",
    offset: 0.449
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92208E",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#931F8E",
    offset: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#941F8E",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951F8E",
    offset: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961F8E",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961F8E",
    offset: 0.473
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#971E8E",
    offset: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981E8E",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#991E8E",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1E8E",
    offset: 0.488
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1D8E",
    offset: 0.492
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B1D8E",
    offset: 0.496
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1D8E",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D1D8E",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1C8E",
    offset: 0.508
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F1C8E",
    offset: 0.512
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F1C8E",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01C8E",
    offset: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A11C8E",
    offset: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A11B8E",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31B8E",
    offset: 0.535
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41A8E",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41A8E",
    offset: 0.543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51A8E",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A61A8E",
    offset: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7198E",
    offset: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8198E",
    offset: 0.559
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9198E",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA198E",
    offset: 0.566
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB198E",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC188D",
    offset: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC188D",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD178D",
    offset: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE178D",
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE178D",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0178D",
    offset: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1168D",
    offset: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1168D",
    offset: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2168D",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3168D",
    offset: 0.613
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4168D",
    offset: 0.617
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5158D",
    offset: 0.621
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6158D",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7148D",
    offset: 0.629
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7148D",
    offset: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8148D",
    offset: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9148D",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9148D",
    offset: 0.645
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA138D",
    offset: 0.648
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB138D",
    offset: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC138D",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD138D",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE128D",
    offset: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF128D",
    offset: 0.668
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0128D",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1128D",
    offset: 0.676
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2118D",
    offset: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3118D",
    offset: 0.684
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3108D",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4108D",
    offset: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5108D",
    offset: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6108D",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7108D",
    offset: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C80F8D",
    offset: 0.711
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C90F8D",
    offset: 0.715
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA0F8D",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB0F8D",
    offset: 0.723
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0E8D",
    offset: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0E8D",
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD0D8D",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0D8D",
    offset: 0.738
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF0D8D",
    offset: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D00D8D",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D10C8D",
    offset: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D20C8D",
    offset: 0.758
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D20C8D",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40B8D",
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D50B8D",
    offset: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60A8D",
    offset: 0.777
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70A8C",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7098C",
    offset: 0.785
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8098C",
    offset: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9098C",
    offset: 0.793
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA098C",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB098C",
    offset: 0.801
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB098C",
    offset: 0.805
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC088C",
    offset: 0.809
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD088D",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE088D",
    offset: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF088D",
    offset: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0078C",
    offset: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1078C",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1078C",
    offset: 0.836
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3068C",
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4068C",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4068C",
    offset: 0.848
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5058C",
    offset: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6058C",
    offset: 0.855
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7058C",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8058C",
    offset: 0.863
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8048C",
    offset: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9048C",
    offset: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9048C",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9048C",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.061,
    gradientTransform: "rotate(-45 45.814 -8.661) scale(16.62609)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0,
    x2: 0.24,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    id: "aS",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F8F",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2F90",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2F90",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D2F90",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D2E90",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E90",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2E90",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2E90",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602E90",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602E90",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612E90",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612D90",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622D8F",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622D8F",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632D8F",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642C8F",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642C8F",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#652C8F",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#652C8F",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C8F",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C8F",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672C8F",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672C8F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692C90",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692C90",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2B90",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2B90",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B2B90",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B2B90",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2B90",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2B90",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2A90",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2A8F",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2A8F",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F2A8F",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F2A8F",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#702A8F",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70298F",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71298F",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72298F",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72298F",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73298F",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73298F",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74298F",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#742990",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#752990",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.006,
    gradientTransform: "rotate(-45 45.462 -8.516) scale(16.62609)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0,
    x2: 0.059,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    id: "aX",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513190",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513190",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513190",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523190",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523190",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533190",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543190",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543190",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553090",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553090",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563090",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563090",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573090",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#583090",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582F90",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582F8F",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.225,
    gradientTransform: "rotate(90 1.502 7.771) scale(23.33256)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    y1: 0,
    x2: 1.013,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    id: "eR",
    xlinkShow: "other"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C70F8D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6108D",
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6108D",
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5108D",
    offset: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5108D",
    offset: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4118D",
    offset: 0.027
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4118D",
    offset: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3118D",
    offset: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3118D",
    offset: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2118D",
    offset: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1118D",
    offset: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1128D",
    offset: 0.059
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0128D",
    offset: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0128D",
    offset: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF128D",
    offset: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE128D",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE128D",
    offset: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD138D",
    offset: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD138D",
    offset: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC138D",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC138D",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB138D",
    offset: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB138D",
    offset: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA148D",
    offset: 0.105
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA148D",
    offset: 0.109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9148D",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9148D",
    offset: 0.117
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8148D",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8148D",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7148D",
    offset: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7158D",
    offset: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6158D",
    offset: 0.141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6158D",
    offset: 0.148
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5158D",
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4168D",
    offset: 0.164
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3168E",
    offset: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3168E",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2168E",
    offset: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1168E",
    offset: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1178E",
    offset: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0178E",
    offset: 0.191
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0178E",
    offset: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF178E",
    offset: 0.199
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF178E",
    offset: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE178E",
    offset: 0.207
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE178E",
    offset: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD178E",
    offset: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD188E",
    offset: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD188E",
    offset: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC188E",
    offset: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB188E",
    offset: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB188E",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA198E",
    offset: 0.242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA198E",
    offset: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9198E",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9198E",
    offset: 0.254
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8198E",
    offset: 0.258
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8198E",
    offset: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7198E",
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71A8E",
    offset: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A61A8E",
    offset: 0.273
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A61A8E",
    offset: 0.281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A51A8E",
    offset: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B8E",
    offset: 0.293
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41B8E",
    offset: 0.297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31B8E",
    offset: 0.305
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A21B8E",
    offset: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A11C8E",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A11C8E",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01C8E",
    offset: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01C8E",
    offset: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F1C8E",
    offset: 0.336
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F1C8E",
    offset: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1D8E",
    offset: 0.348
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D1D8E",
    offset: 0.352
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D1D8E",
    offset: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1D8E",
    offset: 0.359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1D8E",
    offset: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B1D8E",
    offset: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B1D8E",
    offset: 0.371
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1E8E",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1E8E",
    offset: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#991E8E",
    offset: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981E8E",
    offset: 0.387
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981E8E",
    offset: 0.391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#971E8E",
    offset: 0.395
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#971E8E",
    offset: 0.398
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961F8E",
    offset: 0.402
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#961F8E",
    offset: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951F8E",
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951F8E",
    offset: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#941F8E",
    offset: 0.418
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#941F8E",
    offset: 0.422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#941F8E",
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93208E",
    offset: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92208E",
    offset: 0.445
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92208E",
    offset: 0.453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91208E",
    offset: 0.457
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90218E",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90218F",
    offset: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F218F",
    offset: 0.469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F218F",
    offset: 0.477
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E218F",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D218F",
    offset: 0.484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D218F",
    offset: 0.488
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C228F",
    offset: 0.492
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B228F",
    offset: 0.496
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B228F",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A228F",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A228F",
    offset: 0.508
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89228F",
    offset: 0.512
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89238F",
    offset: 0.516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88238F",
    offset: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88238F",
    offset: 0.523
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87238F",
    offset: 0.527
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87238F",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86238F",
    offset: 0.535
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86238F",
    offset: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85238F",
    offset: 0.543
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85248F",
    offset: 0.547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85248F",
    offset: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84248F",
    offset: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84248F",
    offset: 0.559
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83248F",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83248F",
    offset: 0.566
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82248F",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82258F",
    offset: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81258F",
    offset: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81258F",
    offset: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80258F",
    offset: 0.586
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80258F",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F258F",
    offset: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E268F",
    offset: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D268F",
    offset: 0.613
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D268F",
    offset: 0.617
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C268F",
    offset: 0.621
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C268F",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B268F",
    offset: 0.629
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B278F",
    offset: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A278F",
    offset: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A278F",
    offset: 0.641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A278F",
    offset: 0.648
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79278F",
    offset: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78278F",
    offset: 0.656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78288F",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77288F",
    offset: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77288F",
    offset: 0.668
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76288F",
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76288F",
    offset: 0.676
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75288F",
    offset: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75288F",
    offset: 0.684
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74288F",
    offset: 0.688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74298F",
    offset: 0.691
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73298F",
    offset: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72298F",
    offset: 0.699
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72298F",
    offset: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71298F",
    offset: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71298F",
    offset: 0.711
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70298F",
    offset: 0.715
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70298F",
    offset: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F2A8F",
    offset: 0.723
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F2A8F",
    offset: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2A8F",
    offset: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2A8F",
    offset: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2A8F",
    offset: 0.742
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2A8F",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2B8F",
    offset: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B2B8F",
    offset: 0.758
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B2B8F",
    offset: 0.762
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2B8F",
    offset: 0.766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2B8F",
    offset: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692B8F",
    offset: 0.781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692C90",
    offset: 0.785
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90",
    offset: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682C90",
    offset: 0.793
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672C90",
    offset: 0.797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672C90",
    offset: 0.801
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662C90",
    offset: 0.805
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#652C90",
    offset: 0.809
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#652D90",
    offset: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642D90",
    offset: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642D90",
    offset: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632D90",
    offset: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632D90",
    offset: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622D90",
    offset: 0.832
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622D90",
    offset: 0.836
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612D90",
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612D90",
    offset: 0.844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602D90",
    offset: 0.848
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602E90",
    offset: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2E90",
    offset: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2E90",
    offset: 0.863
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E90",
    offset: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E90",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D2E90",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F90",
    offset: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B2F90",
    offset: 0.895
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F90",
    offset: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2F90",
    offset: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592F90",
    offset: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#583090",
    offset: 0.914
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#583090",
    offset: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573090",
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563090",
    offset: 0.934
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553090",
    offset: 0.938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553190",
    offset: 0.941
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543190",
    offset: 0.945
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543190",
    offset: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533190",
    offset: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523190",
    offset: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513290",
    offset: 0.977
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#503290",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0336 .0333 0 7.35 27.138)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAIAAACepSOSAAAABmJLR0QA/wD/AP+gvaeTAAAAIElEQVQImWN8wNzJgAOw/GPEJcXA8h+nFNn6mHBLMQAAdp8FfHW1nl0AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03467 0 8.232 28.253)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM8wt3JAAMs/xkYsHMAV7gDYI5TUMMAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03455 0 8.068 28.09)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAABmJLR0QA/wD/AP+gvaeTAAAAF0lEQVQImWM8ydnJAAMs/xkZkDgMODgAkIAEZ/SS2uwAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03286 .03286 0 1.63 30.75)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 756,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,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",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 641,
    xlinkShow: "embed"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03286 .03287 0 21.636 28.09)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 496,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfAAAACTCAIAAAD+2dzxAAAABmJLR0QA/wD/AP+gvaeTAAACJUlEQVR4nO3UQQ3AIADAwDFDfLCIb0wsWWjuFPTVseZ+ALjf+3cAAN8wdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdIAIQweIMHSACEMHiDB0gAhDB4gwdICIA3CuAg6ERo+jAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 147,
    xlinkShow: "embed"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03371 .03449 0 6.063 24.148)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAFCAIAAAAcxIEBAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWN8xtTJgBcw4ZemmwoA9oEBe6nrXyoAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 16.847 9.73) scale(.03467)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAABmJLR0QA/wD/AP+gvaeTAAAAF0lEQVQImWN8xtTJwMDAwMDAxAADCBYAKTEBd4tcL4cAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03308 .03325 0 22.752 10.286)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 23,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAIAAADp3DFZAAAABmJLR0QA/wD/AP+gvaeTAAAAHklEQVQ4jWM00W9loBgwUW7EqCmjpoyaMmrKCDEFAGXCARAis3wJAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 20,
    xlinkShow: "embed"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03449 .03449 0 9.087 29.239)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAIAAAACDbGyAAAABmJLR0QA/wD/AP+gvaeTAAAAHUlEQVQImWNcI9jJgARY/jOgAJZ/jCh8JlRpDD4A08gDUhBx7F4AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0344 .03343 0 8.43 28.616)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAIAAABLMMCEAAAABmJLR0QA/wD/AP+gvaeTAAAAJElEQVQImWPcz9PJgAFY/mGKMTAwYRNkYPnHSLza/zhMwCIOAPx/BmTQbqiGAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03305 .03304 0 23.443 11.832)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 46,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAiCAIAAACvGXwbAAAABmJLR0QA/wD/AP+gvaeTAAAAP0lEQVRYhe3OoQHAIADAMOChGV7k78mZeiaSCzL3c8Y/rNuBj0pRKSpFpagUlaJSVIpKUSkqRaWoFJWiUlTKC0AOASyQzscPAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 34,
    xlinkShow: "embed"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M 18.230469 8.34375 L 19.609375 9.722656 L 20.988281 8.34375 L 19.609375 6.964844 Z M 18.230469 8.34375"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M 18.480469 28.796875 L 20.457031 30.773438 L 22.4375 28.796875 L 20.457031 26.816406 Z M 18.480469 28.796875"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#592F8F",
    d: "M 20.117188 29.054688 L 20.148438 29.085938 L 20.179688 29.054688 L 20.148438 29.023438 Z M 20.117188 29.054688"
  })))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9048C",
    d: "M 22.617188 9.472656 L 22.667969 9.527344 L 22.71875 9.472656 L 22.667969 9.421875 Z M 22.617188 9.472656"
  })))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M 25.121094 22.625 L 25.328125 22.832031 L 25.535156 22.625 L 25.328125 22.421875 Z M 25.121094 22.625"
  })))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03343 .03353 0 22.026 9.17)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAIAAAC6ZnJRAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM00W9mwABMmEKDRBQAojUA9vEm5KsAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 8,
    xlinkShow: "embed"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03344 .03298 0 18.38 8.582)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABSCAIAAADSAcNRAAAABmJLR0QA/wD/AP+gvaeTAAAALUlEQVRIie3LMQEAMAjAsDFDPDjEOBrgTu8mKvtt+qsbAAAAAAAAAAAAAIATGC+kAYplJJWKAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 82,
    xlinkShow: "embed"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03343 .03371 0 21.075 8.643)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAIAAAA88gD/AAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM00W9mwABMmELDRhQA4qkA/MDsx9gAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 11,
    xlinkShow: "embed"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03308 .0344 0 25.933 15.739)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 17,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAHCAIAAABhgDErAAAABmJLR0QA/wD/AP+gvaeTAAAAGUlEQVQYlWM00W9mIBEwkaphVA8DAwMDAwBQXAD01al6GwAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03287 .0329 0 19.2 29.601)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 218,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,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",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 192,
    xlinkShow: "embed"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03438 .03343 0 23.443 10.587)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM00W9mwAaYsIoOtAQAoJcA9M9lsOYAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03338 .0332 0 23.443 11.08)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 23,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAIAAAD02QHhAAAABmJLR0QA/wD/AP+gvaeTAAAAXUlEQVQ4jaXMsRHAMAhDUchAOY/n8dP5fASDJKv6ap6/Y5o4X/XcE7Li4QtKJAQlIVglJyjlSOBKRYBKQyBKT7QKRNQKShQKQZwUjkgVmvgrChEUkdgVnVjKFWFmH+97AQ9a1bIVAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 19,
    xlinkShow: "embed"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03326 .03366 0 24.195 11.763)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAIAAADgjEOTAAAABmJLR0QA/wD/AP+gvaeTAAAAFklEQVQYlWM00W9mIAIwEaNoVB3F6gB2hAD6z9aC8QAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 10,
    xlinkShow: "embed"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03308 .03344 0 23.997 11.763)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 23,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAQCAIAAAByTXNPAAAABmJLR0QA/wD/AP+gvaeTAAAAVUlEQVQ4jaXOQQoAIQwDwGQfJD7P5+9BEBG1seklyWUoS22w7/MJgL5C2L+wh6NwtLTCeeQULjuhrERC2RCvyp54Uo6ErtwIUQkIRYmJUJGIu6ISAH4O5gEFqYkuOwAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 16,
    xlinkShow: "embed"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03303 .03366 0 25.475 22.964)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 22,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAKCAIAAAA/wjmMAAAABmJLR0QA/wD/AP+gvaeTAAAAGElEQVQokWM00m9koAwwUah/1IhRI3AAAGpRAPYiRHtQAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 10,
    xlinkShow: "embed"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03334 .03343 0 26.002 21.226)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 22,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAHCAIAAACDXCpSAAAABmJLR0QA/wD/AP+gvaeTAAAAMUlEQVQYlWM00m9kIAswwhhMFOon0whGVC7JRjBiiJBmBKZ+0ozAqp8EI3DpZ2BgAACwqwD3wiyFogAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03317 .03298 0 25.742 22.177)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 25,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAKCAIAAADOyWIBAAAABmJLR0QA/wD/AP+gvaeTAAAAGUlEQVQokWM00m9koBJgopZBo2aNmkVjswC9owD2DmgTbgAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 10,
    xlinkShow: "embed"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03315 .03449 0 26.2 20.173)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAFCAIAAADHfysjAAAABmJLR0QA/wD/AP+gvaeTAAAAFUlEQVQYlWM01m9iIB0wkaFnqGgDAPlHAO6DksC6AAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0332 .03455 0 26.296 19.317)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAECAIAAADj4ZO4AAAABmJLR0QA/wD/AP+gvaeTAAAAIElEQVQImWM01m9iIBkwMjAwMJGnjQydjHAWSToZkTkA0o8A8NHCT2EAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03315 .03467 0 26.33 18.4)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAADCAIAAAARJsg+AAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM01m9mIB0wkaGHfG0AlBMA64IKEWUAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03301 .03467 0 26.33 18.332)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAADCAIAAAAV0xgDAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM6hgIAUwkaSaHA0AezgA3JX/G+QAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aA)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03366 .03467 0 26.33 18.633)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAIAAAAlXwkiAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM6hgwA2Y8MgRlgYATTwA3GgfB/IAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aB)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aC)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03304 .03449 0 26.262 17.84)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 28,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAFCAIAAADZthuQAAAABmJLR0QA/wD/AP+gvaeTAAAAKElEQVQYlWM01m9mwACMmEKkACaqm4jFUMpNRDeUKiaiGEotExkYGACIwwD0d6qVQQAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aD)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aE)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0336 .03455 0 26.132 16.3)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAECAIAAADTbYKZAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM00W9mwAGYcElQIAcAZLUA7qAzu5UAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aF)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aG)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aH)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M 4.117188 18.847656 L 20.097656 34.832031 L 36.082031 18.847656 L 20.097656 2.863281 Z M 4.117188 18.847656"
  })))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aK)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aL)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03288 .03334 0 23.997 25.23)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 35,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAWCAIAAADFDLIQAAAABmJLR0QA/wD/AP+gvaeTAAAAhElEQVRIib3UQQ6AIAxE0V8O46m8j8fWhUShZfthRSDhhUkzcR4XAMRN30A6SSvKpl69qw0vtD1MlzYwQNvDxJ+ezNDT8xmg7WGizp7EkGbPYxhnT2X40rOZtWQwcRdJYkh/8phJUhkWbeQw5DbSGKY2MplFl0sMKT2PYUxPZaJ2hMQADxcPMLlWN+6IAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 22,
    xlinkShow: "embed"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aM)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aN)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0331 .03444 0 25.112 23.094)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAIAAACaUPOvAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUN6hmwAuY8EsPIhUAsUwA5pINucsAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aP)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aQ)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M 19.210938 28.085938 L 21.316406 30.191406 L 23.417969 28.085938 L 21.316406 25.984375 Z M 19.210938 28.085938"
  })))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aT)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aV)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M 19.113281 29.285156 L 19.730469 29.902344 L 20.347656 29.285156 L 19.730469 28.667969 Z M 19.113281 29.285156"
  })))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aY)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aZ)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03695 .03455 0 19.173 29.601)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAIAAADETxJQAAAABmJLR0QA/wD/AP+gvaeTAAAAF0lEQVQImWPUN6hnYGBgYGBgYoABbCwAIWwA5m7IZcgAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .0333 0 19.173 29.601)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAIAAABrW6giAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUMyhhgAEmBiRADgcAQDQA3lM94V4AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#642D8F",
    d: "M 23.496094 10.269531 L 23.414062 10.269531 L 23.414062 10.367188 L 23.496094 10.367188 Z M 23.496094 10.269531"
  }))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#74298F",
    d: "M 24.5625 11.789062 L 24.535156 11.789062 L 24.535156 11.832031 L 24.5625 11.832031 Z M 24.5625 11.789062"
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03438 .0344 0 23.306 10.422)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM0MKhnwAaYsIoOtAQAm9wA7blNke8AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bk)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0344 .0344 0 23.306 10.422)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAIAAABLMMCEAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM6hiwABMmEJ0FwUAhMQA5t9z8LwAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03695 0 25.406 23.129)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM00W9mgAEmBiSAwgEAIYsA7G5yzxEAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03467 0 26.132 16.101)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM01G9kgAEmBiSAwgEAINEA57sAwyEAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03343 .03449 0 25.31 13.57)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAIAAAAG+GGPAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWM0NGhgwABMmEJUEQUAYTEA6zhI8KQAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03467 .03455 0 22.19 9.17)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 3,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAIAAADETxJQAAAABmJLR0QA/wD/AP+gvaeTAAAAF0lEQVQImWPUN6hnYGBgYGBgYoABbCwAIWwA5m7IZcgAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03292 .03292 0 20.747 9.663)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 36,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAIAAABttA1UAAAABmJLR0QA/wD/AP+gvaeTAAABBUlEQVRYheXYTRLDIAgFYPQuvVRP1FvbRcZUU1R4gIuEVWai+epUXn7S+/WhWiXVA/pVuRyk4al2Vnu181Tup/M1GrCe2PsZlq4LWUl0rCxCYmuG+UozzF0aYvCOQLAISYfZ6znYfydqa/LXdlio1GH2zba8QhaOsw8gY+qrJDKlvlIi+9aXS8mKiXfv8Zt2NPXZUeFY27sMZm/tUeErA0IAxJB+KBCGScSkfoRUq0/9SIlUqW8f4Jb6knrOM8il5GkivXnukWaYIiHFIwfP+gESj6luvqq6Req7YXCa+Ke+FItOyHu/eWo/1ODYNonwLzzumK80w9ylIRYh8ViQxGNxtRX7AqN5IJ4ELiwYAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 52,
    xlinkShow: "embed"
  }))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03308 .03319 0 25.345 22.54)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 35,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAMCAIAAABnQZPtAAAABmJLR0QA/wD/AP+gvaeTAAAAlElEQVQ4ja2SyxHAIAhEV2pI0WkjlZJDouGrjBMOjujCE6Rdx8l4reEzlm53JkrW56yTMEAwwaxdmT7CSLdZobqiEBNssnT+ZYmSfsFU6qavo0bhgo1ygjHZnpVCjG9FhkmVfTME5LNnHfflLjHS1RNRwKzr9gIG1EQU5mcbg7B7G5iK0nbPqOu/uHwQ+aM9TBYy7AYawCxz09CYrgAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 12,
    xlinkShow: "embed"
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03286 .03287 0 20.747 23.129)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 449,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,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",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 173,
    xlinkShow: "embed"
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bA)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bB)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03286 .03303 0 24.948 22.342)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 298,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASoAAAAtCAIAAACWKrF0AAAABmJLR0QA/wD/AP+gvaeTAAABeElEQVR4nO3cS27CQBREUcyComwu608GiQghBrs/drdU58wRfqiuYMTy9v5xgWKf5S9Z+j9FH7dbjnvC9Y/retj7wb1p27sZ8ITy4wTaWyc/jqa9p+THoeZvbyT5cRztbZAfB9HeNvlxBO3tIj+6095e8qMv7RWQHx1pr4z86EV7xeRHF9qrIT/aaa+S/GikvXryo4X2msiPatprJT/qaK8D+cEw8oNRFvlV8LuLdsvFt1857dHuZ0XyK6I92v2uSH77aY92f1ZUl1/gEANPprvHFVXkFzjEwJPpbmVFpfkFDjHwZLpbX1FRfoFDDDyZ8+zPL3CIgSdzqp35BQ4x8GTOtie/wCEGnswAm/kFDjHwZMZ4nV/gEANPZpgX+QUOMfBkRnqWX+AQA09msNX8AocYeDLj/c8vcIiBJzOFh/wChxh4MrO4zy9wiIEnM5FbfoFDDDyZuXznFzjEwJOZzjVyiIEnM6PAP5vQHrNIy097TCQqP+0xly93rgRzZKtRFAAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 45,
    xlinkShow: "embed"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bC)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bD)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03308 .03303 0 23.573 11.435)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 29,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAWCAIAAACzNgCbAAAABmJLR0QA/wD/AP+gvaeTAAAAI0lEQVQ4jWPUMyhhoAFgooWho+aOmjtq7qi5o+aOmjtMzQUA4IAA/oVG8A0AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 22,
    xlinkShow: "embed"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bE)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bF)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03321 .03319 0 25.379 14.33)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 26,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAMCAIAAADzpzofAAAABmJLR0QA/wD/AP+gvaeTAAAAG0lEQVQokWPUM8hmoB5goqJZo8aNGjdqHBYAABbWAOFybhzUAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 12,
    xlinkShow: "embed"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bG)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bH)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03449 0 21.007 8.513)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAIAAADtz9qMAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hkgAEmBiRAJAcAMkQA0bWSQW8AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bI)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bJ)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03319 .03326 0 22.259 9.499)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAIAAAASSxgVAAAABmJLR0QA/wD/AP+gvaeTAAAANUlEQVQYlWPUM8hiYGBgYPjPgAIYkTlMDFgAIxofUxG6CkxFWFSgKcKuAlkRThVY3TTiFAEAb1cB55Gb+w8AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 13,
    xlinkShow: "embed"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bK)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bL)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0332 .03353 0 22.813 10.258)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAIAAAA2bnI+AAAABmJLR0QA/wD/AP+gvaeTAAAAG0lEQVQ4jWPUM8hiIAswkadtVOeozlGdg1onAHt9AOwRwIT9AAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 18,
    xlinkShow: "embed"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bM)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bN)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0338 .0344 0 25.146 13.378)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAHCAIAAABcElBNAAAABmJLR0QA/wD/AP+gvaeTAAAAFUlEQVQYlWPUM8hmIAIwEaNoGKkDAOLJANd7QuCGAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bP)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03343 .03312 0 25.413 23.094)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAIAAAAG+GGPAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hiwABMmEJUEQUAVrgA0vfp9qAAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bQ)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bR)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03353 .03455 0 25.967 21.39)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hiwAaYsIqSJQEATkgA0E3UymYAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bS)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bT)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03371 .03455 0 26.166 20.44)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAECAIAAADXmFKkAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hiwAuY8EtTSQUAaxwA0H+vIW0AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bV)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03376 .03467 0 26.296 19.618)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAADCAIAAAAoQXllAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hmIASYCKogVhEAVxQAz4YwtgYAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bW)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bX)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03301 .03467 0 26.33 18.332)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAADCAIAAAAV0xgDAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUMyhmIAUwkaSaHA0AeGgA18ph+D8AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bY)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bZ)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0331 .03467 0 26.33 18.66)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAADCAIAAADKnWIcAAAABmJLR0QA/wD/AP+gvaeTAAAAGElEQVQImWPUMyhhwAL+w1lM2KRRAGEVAKEMAdf//RonAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0331 .03467 0 26.33 18.66)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAADCAIAAADKnWIcAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hmwAuY8EsTpQIAT98Az6cqjcUAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03291 .03444 0 26.166 16.854)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 20,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAABmJLR0QA/wD/AP+gvaeTAAAAIUlEQVQYlWPUM8hiYGBgYGBkIB0wka0ToplMnXCbh5xmACm2ANcFw4H1AAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03312 .03467 0 25.967 21.452)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAIAAADUVFKvAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hmQAJMDKgAnQ8AJKEAz0vKIzgAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 3,
    xlinkShow: "embed"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03455 0 23.963 11.107)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUMyhkgAEmBiSAmwMAKS8A16TYnzUAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03438 .03455 0 26.132 20.604)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hmwAaYsIqSJQEATqkA0Ytfz3wAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03449 .03455 0 25.276 13.44)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAIAAADJUWIXAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPUM8hgQAJMDKiAEB8AMPoAzsKxVfIAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cn)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03455 0 22.225 9.204)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWPU009jgAEmBiSAmwMAJuIAy6iDVnUAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03286 .03288 0 18.38 22.54)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 428,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,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",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 235,
    xlinkShow: "embed"
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cr)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0329 .03294 0 18.38 15.185)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 171,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,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",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 69,
    xlinkShow: "embed"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ct)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.033 .03295 0 23.244 11.633)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 33,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAaCAIAAAC2O6JWAAAABmJLR0QA/wD/AP+gvaeTAAAA2klEQVRIibXWWxKDIAwF0BuW0uV1I9116QeDvJJwLZEPhsHgkYdReb8+AATIQK4N1FotWWrDjvm2W+VUgFJkCV17yIC+Pz0BTCX9PV6clSIN3+MBymAAf1c2BrPiYj1KbeiGNUyJzK22Hk4xYgHF4AETXnrSejkWEAh1dtXxzDs7nKvteZ/SwY3dKoa1dQFABoB0aaHAEDXk3RPgWoYJQJ93T4BOUqL2efcQ8AyyiNoMNLq5evNccgn9YSCB2ejORhgwGG1YKNAM58/hEMD0Dj4BwP/3saV76f8HdJkhnKA1lDkAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 26,
    xlinkShow: "embed"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cv)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0331 .03353 0 25.803 17.251)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 36,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAICAIAAAAeDMqCAAAABmJLR0QA/wD/AP+gvaeTAAAAb0lEQVQokaWTSRKAIAwEO/mG79Vvw8ESwzKSKnOCbA1DsPO4AMCgkLXylPRmd8hEphM2XdHOlqRlbfN4hpTwyOPFgCvSvNDtMkJAk1H1zZMSmQGWVy9cevNOgzzjgHyo5/9IDAPyeqdPoEhzpiIZVH03B3JmGHpkAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 8,
    xlinkShow: "embed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0331 .03353 0 25.803 17.251)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 36,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAICAIAAAAeDMqCAAAABmJLR0QA/wD/AP+gvaeTAAAAbElEQVQokb2RQQ6AIAwEZ/mIn/QNPtt6Ea0UQo2Jcyq0y4RU67IZAIJdePZ6DxgIDEzn0bfMpSwU1FTBxSIKRWzlKb+ZgNLEZO1ExxRmRjTZ0n3lLtKm6e9lT9nUNCJjgp7sLfmNfpVldnxxAIoJFjbi1GacAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 8,
    xlinkShow: "embed"
  }))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03302 .03455 0 25.967 19.618)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 39,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAECAIAAACC+bH6AAAABmJLR0QA/wD/AP+gvaeTAAAAU0lEQVQYlZWOQQ6AQAgDB77hd43fxsvGbaDG2BPpQEucx1VsxR4CKHFUBQlFOdgVrL0nMxvWShoWTd8+ZzNDzy22ibPgc7NlrtZ8wTMoh/+3ErgBeOMIViROcj8AAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03302 .03455 0 25.967 19.618)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 39,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAECAIAAACC+bH6AAAABmJLR0QA/wD/AP+gvaeTAAAAWklEQVQYlZWQUQ6AMAhDX3cML2y8tPVHxpZtZvaD0IZSgq7jBABjC5mXSqFnTUUAtgGLFjeodyWNydIaaiTqN/2BFrTVCyMicmoY6c4F2Xiauh9pvjEeV3/5APHgFjrtAYPNAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03299 .03326 0 25.345 22.54)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 38,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAANCAIAAABKNIsMAAAABmJLR0QA/wD/AP+gvaeTAAAAlElEQVQ4jb2Syw2AMAxD7Q7CmmzA2uYA9JM0LUKiPiHj5KmRuW+HiEsUahETsfoQVDvymQeTyrzslrHy5GCkZERrRrwI/Jl3+yt5BBKDYb+Fr3mlE453b1jJQ1OfH3jdZPLWSx7kksqZhpfaWHPYBTzk+nTBhlcwM57ZYJzwsKbJH3j+fZ3GLuChPuyc55PBrwGPwAkqESKdGMl1ugAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 13,
    xlinkShow: "embed"
  }))))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cA)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cB)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03288 .03291 0 22.847 18.435)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 255,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAABjCAIAAADbzkGlAAAABmJLR0QA/wD/AP+gvaeTAAAD00lEQVR4nO3dQXoTQQxE4Y4vBNfj9LAhTpzYjmemSt01ev+eRiO/JZ94+/X7z/B4O/zC321/3fG/cKYHH/viDiK+fdPvWfHyRTvFVfGvkZ7+MZu/vfOyPrPUT/qFSH8/ff2kX4j0DxHXT/qFSP8oZf2kX4j0BWT1k34h0tfQ1E/6hUhfRlD/a8uV/QSk7/0DnRytn/QLkb7YofpJvxDp6+2vn/QLkb7FzvpJvxDpu+ypn/QLkb7R5vpJvxDpe22rn/QLkb7dhvqL0+/9a5J+hVfrJ/1CpF/kpfpJvxDp1/m5ftIvRPqlfqif9AuRfrVn9ZN+IdKf4GH9pF+I9Oe4Xz/pFyJ9lc2LuVM/6RcifZU9i/laP+kXIn2VnYu5qf8U6acUQvoq+xfzUT/pFyJ9lUOLuWx5g/QlSF/l6GIuL79B+hKkryJYzIX0C5G+imYxr/wrN9KXIH0V2WJ+rJ/0JUhfRbmY5/WTvgTpq4gX86R+0pcgfRX9Yh7VT/oSpK9iWczd+klfgvRVXIv5Xj/pSzRK3zy58fkv9ZO+RMqcArnpj9v6SV8iZU6B6PTHp/pJXyJlToH09Md7/aQvkTKnwAnSH2NcSF8kZU6Bc6Q/pP9nI+m3cJr0h65+0m/hTOkPUf2k38LJ0h+K+km/hfOlPw7XT/otnDL9cax+0m/hrOmPA/WTfgsnTn/srZ/0Wzh3+mNX/aTfwunTH9vrJ/0WOqQ/NtZP+i00SX9sqZ/0W+iT/ni5ftJvoVX6o/yalfVNh5Q5BRp96rvKa1bWNx1S5hRo9KmflF2zsr7pkDKnQKNPvVVzzcr6pkPKnAKNPvWbgmtW1jcdUuYUaPSp97ivWVnfdEiZU6DRpz5gvWZlfdMhZU6BRp/6mO+alfVNh5Q5IWO6ZmV90yFlTig5rlldpSSVMifE5NesrlKSSpkTetprVlcpSaXMCQvhNaurlKRS5oSLvP6UpFLmhJG2/pSkUuaE1+J3PB1S5oTdync8HVLmRIVl73g6pMyJImve8XRImRN1Frzj6ZAyJ0qtdsfTIWVOVFvqjqdDypyYYJ07ng4pc2KORe54OqTMiWlWuOPpkDInZpp+x9MhZU5MNveOp0PKnJhv4h1Ph5Q5sYRZdzwdUubEKqbc8XRImRMLqb/j6ZAyJ9ZSfMfTIWVOLKfyjqdDypxYUdkdT4eUObGomjueDilzYl0FdzwdUuZcX+tNuu94OqTMub7um7Te8XRImXN9bNJ4x9MhZc71sckxbHc8HVLmXB+b/M9xx9OBH0yFTX6IqJ8fTIVN3li/fn4wFTb51T9SUwhAyrIQDgAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 99,
    xlinkShow: "embed"
  }))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cC)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cD)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.033 .0329 0 23.278 11.633)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 33,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAZCAIAAAAwr9D4AAAABmJLR0QA/wD/AP+gvaeTAAAAZklEQVRIie3POw6AMAwD0JgDVeJu3L8MlSqo+oPYW7zEnp6CdF6mSM61HRLgnTDCCGMYqA2Y+A+UozNQm8jAcygMNJtutADd6ABcow8QjSHAMmYAxVgAfmMNOI0twGPsAr+ND4CZ3VTVBBIfVGvrAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 25,
    xlinkShow: "embed"
  }))))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cE)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cF)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03292 .03325 0 24.325 13.241)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 36,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAIAAABqGAhiAAAABmJLR0QA/wD/AP+gvaeTAAAAYklEQVRIib3N2w3AIBADQaCipMG0Tio4zi+xv5Y8832+UbcPW9Gsp8W/iVIYO0tJrJViGCJlMFAKYLjkYpRkYaykY4IkYpqkYLJEY47EYaZEYL6EYhEJwlJSjwWlHst2FfsBzXoCGDye8FIAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 20,
    xlinkShow: "embed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03292 .03325 0 24.325 13.241)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 36,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAUCAIAAABqGAhiAAAABmJLR0QA/wD/AP+gvaeTAAAAYUlEQVRIib3NyQ3AMAwDQdsVqb8Un1QgixeyXwKcXfWsvveyNe1+OvybKIWxu5TERimGIVIGA6UAhksuRkkWxko6JkgipkkKJks05kgcZkoE5ksoFpEgLCXNWFCasWy/Yh+rdAIUiFKaDgAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 20,
    xlinkShow: "embed"
  }))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cG)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cH)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03315 .03315 0 22.355 10.156)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAABmJLR0QA/wD/AP+gvaeTAAAAY0lEQVQokdXTsQ3AIAxE0X/MksWyTbYmrUE+MEWKUCAk82QbGd3XAwA97PEAoDnU8Es+ZNnCWLY2OduahFVMnu0rpolVKlQfs9UNR0UqDE6ZDcNGUzf3vCllS3veMPdOv/gBLyheDDjlR/aQAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 18,
    xlinkShow: "embed"
  }))))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cI)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cJ)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#941F8E",
    d: "M 5.878906 19.308594 L 5.859375 19.308594 L 5.859375 19.539062 L 5.878906 19.539062 Z M 5.878906 19.308594"
  }))))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cL)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cM)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#503290",
    d: "M 9.714844 29.621094 L 9.660156 29.621094 L 9.660156 29.671875 L 9.714844 29.671875 Z M 9.714844 29.621094"
  }))))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cP)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#503290",
    d: "M 9.914062 29.8125 L 9.882812 29.8125 L 9.882812 29.835938 L 9.914062 29.835938 Z M 9.914062 29.8125"
  }))))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cR)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cS)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#513290",
    d: "M 9.585938 29.519531 L 9.539062 29.519531 L 9.539062 29.558594 L 9.585938 29.558594 Z M 9.585938 29.519531"
  }))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cV)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#523190",
    d: "M 9.4375 29.375 L 9.382812 29.375 L 9.382812 29.425781 L 9.4375 29.425781 Z M 9.4375 29.375"
  }))))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cX)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cY)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#503290",
    d: "M 9.824219 29.742188 L 9.800781 29.742188 L 9.800781 29.761719 L 9.824219 29.761719 Z M 9.824219 29.742188"
  }))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#503290",
    d: "M 9.996094 29.902344 L 9.992188 29.902344 L 9.992188 29.910156 L 9.996094 29.910156 Z M 9.996094 29.902344"
  }))))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#543190",
    d: "M 9.09375 29.007812 L 9.003906 29.007812 L 9.003906 29.09375 L 9.09375 29.09375 Z M 9.09375 29.007812"
  }))))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dh)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#di)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7C268F",
    d: "M 6.003906 23.035156 L 5.957031 23.035156 L 5.957031 23.289062 L 6.003906 23.289062 Z M 6.003906 23.035156"
  }))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dk)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6B2B8F",
    d: "M 6.773438 25.53125 L 6.691406 25.53125 L 6.691406 25.714844 L 6.773438 25.714844 Z M 6.773438 25.53125"
  }))))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dn)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#do)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6E2A8F",
    d: "M 6.589844 25.0625 L 6.503906 25.0625 L 6.503906 25.277344 L 6.589844 25.277344 Z M 6.589844 25.0625"
  }))))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dr)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#71298F",
    d: "M 6.378906 24.589844 L 6.339844 24.589844 L 6.339844 24.703125 L 6.378906 24.703125 Z M 6.378906 24.589844"
  }))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ds)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dt)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#du)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F258F",
    d: "M 5.875 22.46875 L 5.871094 22.46875 L 5.871094 22.5 L 5.875 22.5 Z M 5.875 22.46875"
  }))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dx)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#82248F",
    d: "M 5.839844 22.011719 L 5.824219 22.011719 L 5.824219 22.152344 L 5.839844 22.152344 Z M 5.839844 22.011719"
  }))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dy)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dz)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#682C90",
    d: "M 6.96875 25.941406 L 6.875 25.941406 L 6.875 26.128906 L 6.96875 26.128906 Z M 6.96875 25.941406"
  }))))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dB)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dC)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#553090",
    d: "M 8.882812 28.800781 L 8.808594 28.800781 L 8.808594 28.875 L 8.882812 28.875 Z M 8.882812 28.800781"
  }))))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dE)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dF)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E2E90",
    d: "M 7.738281 27.433594 L 7.726562 27.433594 L 7.726562 27.449219 L 7.738281 27.449219 Z M 7.738281 27.433594"
  }))))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dH)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dI)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#593090",
    d: "M 8.488281 28.316406 L 8.386719 28.316406 L 8.386719 28.4375 L 8.488281 28.4375 Z M 8.488281 28.316406"
  }))))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dK)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dL)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5C2F90",
    d: "M 8.054688 27.75 L 7.949219 27.75 L 7.949219 27.890625 L 8.054688 27.890625 Z M 8.054688 27.75"
  }))))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dN)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dP)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.98684 .98684 0 6.908 27.75)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABmJLR0QA/wD/AP+gvaeTAAAADElEQVQImWNI0JsAAAIQAR94nkLZAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 1,
    xlinkShow: "embed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 .98684 0 6.908 26.763)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABmJLR0QA/wD/AP+gvaeTAAAADElEQVQImWNI0JsAAAIQAR94nkLZAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 1,
    xlinkShow: "embed"
  })))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dQ)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dR)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#662C90",
    d: "M 7.164062 26.347656 L 7.078125 26.347656 L 7.078125 26.507812 L 7.164062 26.507812 Z M 7.164062 26.347656"
  }))))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dT)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dU)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#632D90",
    d: "M 7.390625 26.730469 L 7.289062 26.730469 L 7.289062 26.902344 L 7.390625 26.902344 Z M 7.390625 26.730469"
  }))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dW)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dX)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03286 .03287 0 4.36 29.964)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 562,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjIAAAErCAIAAABLn/7AAAAABmJLR0QA/wD/AP+gvaeTAAAFEElEQVR4nO3dsZHDMAwAQcqD5r9RlyE4ersEXbBbgbMbghB9vV9/BwAaXk//AAD4kSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAIkSUAQuZ++hcAwNfs9fRPAIB/TksAhMw+/QsA4MvKAwAhc7tbAiDDEA+AEKclAEKclgAIsfIAQIgsARBiiAdAiFceAAjxJh4AIe6WAAgxxAMgxBAPgBCnJQBCLIgDEGLlAYAQd0sAhBjiARBiiAdAiP9bAiDEEA+AEEM8AEJ8TgtAiAVxAELcLQEQIksAhFh5ACDEd0sAhBjiARAiSwCEGOIBEGLlAYAQWQIgxN0SACHexAMgxBAPgBCbeACEOC0BEGLlAYCQuS9hAqDCaQmAEFkCIMTKAwAhsgRAyOzlwyUAKtwtARDiTTwAQtwtARAy62oJgAx3SwCEyBIAIf7YAoAQKw8AhBjiARAiSwCEuFsCIMTdEgAhsgRAiCwBEOKpVgBCbOIBEDJ7CRMAFYZ4AIRYeQAgRJYACPHKAwAhNvEACJk9jksAVLhbAiBElgAImTXDAyDDygMAIXMfYQKgwuNDAIRYeQAgRJYACPH4EAAhNvEACJElAELcLQEQ4pUHAEJmfU4LQIYhHgAhVh4ACHG3BECIIR4AIYZ4AIR4QRyAEEM8AEJkCYAQL4gDEGLlAYAQQzwAQmziARDitARAiCwBEOJNPABCZo8uAVBhQRyAEHdLAITIEgAhHh8CIMTdEgAhc44wAVBhiAdAiJUHAELcLQEQ4rQEQIgsARDi/5YACPGCOAAhhngAhMgSACHulgAI8d0SACGGeACEyBIAIRbEAQhxtwRAiCwBEOJuCYAQpyUAQpyWAAixiQdAyOzRJQAqZo/bJQAq3C0BEGITD4CQcbUEQIfTEgAh/gYQgBArDwCEyBIAIbIEQIjHhwAIsYkHQIghHgAhsgRAiCEeACE+pwUgxJt4AIQY4gEQYuUBgBCnJQBCZAmAEEM8AEJkCYAQT7UCEOK0BECIlQcAQmQJgBBDPABC5rbyAECG0xIAIe6WAAhxWgIgxGkJgBBZAiDEEA+AEFkCIESWAAjxgjgAIVYeAAhxWgIgxN0SACGGeACEOC0BEOK0BECI0xIAIU5LAIQ4LQEQMsd3SwBkGOIBECJLAIS4WwIgRJYACDHEAyDEaQmAEKclAEKclgAI8TeAAIQY4gEQYogHQIgsARBiiAdAiNMSACFOSwCEWBAHIMQQD4AQWQIgRJYACLHyAECILAEQYogHQIgFcQBCnJYACJElAEJkCYAQm3gAhMgSACGGeACEyBIAIYZ4AIQ4LQEQ4rQEQIjTEgAh3sQDIMRpCYCQD2gVh1L21ozHAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 299,
    xlinkShow: "embed"
  }))))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dY)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dZ)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03353 .03444 0 8.232 28.383)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAABmJLR0QA/wD/AP+gvaeTAAAAIUlEQVQImWNcKtzGgA2w/GPEKs7A8g+7OG4dTDg04JYAAOXqBEx3Sr/zAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03343 .0333 0 8.006 28.09)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAIAAACAbBMhAAAABmJLR0QA/wD/AP+gvaeTAAAAIUlEQVQImWPcINjGgAGYMIUYGBhY/mIV/c9IvNp/2NQCAIH+BVTP6w+gAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03286 .03287 0 4.36 29.964)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 562,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAjIAAAErCAIAAABLn/7AAAAABmJLR0QA/wD/AP+gvaeTAAAFI0lEQVR4nO3dwZEbMQwAQdKF3J2mE1nufXRyCJxHdwT7mwIJUfvf/F0A0PDn9gcAwH+yBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBECILAEQIksAhMgSACGyBEDIPPv2JwDAr3n2e/sbAOBjnttfAABfcxziAZBh5QGAECsPAIS4WwIgxLQEQMhYDwegw8oDACGyBECIuyUAQmQJgBCvPAAQ4m4JgJB5lnEJgAp3SwCEzLn9BQDwZeUBgBArDwCEmJYACHG3BECIQzwAQubZ/toCgAp3SwCEOMQDIGSe218AAF/zOsQDIMO0BECIlQcAQqw8ABDilQcAQhziARBiWgIgxLQEQIiVBwBCZAmAkPF+OAAd87hbAiDDJh4AIXO2cQmACisPAIQ4xAMgZM4WJgAqLIgDEOLxIQBCrDwAECJLAITYxAMgZF53SwBkzLN0CYAKd0sAhFgQByDEz2kBCLGJB0CITTwAQqw8ABDiEA+AEJt4AISYlgAIcbcEQIgsARAiSwCEzGPlAYAM0xIAIXO2V/EAqPBUKwAhDvEACPHKAwAhXnkAIMTdEgAhDvEACLHyAECILAEQ4m4JgBBZAiBkzrIiDkCF3y0BEGLlAYCQebcfLgFQ4RAPgBCHeACEmJYACDEtARAyr40HADLmLO88AFDhEA+AEG/iARDibgmAEId4AIQ4xAMgRJYACHG3BECIuyUAQhziARBiWgIgxAviAIQ4xAMgxCEeACGyBECI3y0BEOJuCYAQWQIgRJYACLHyAECIlQcAQkxLAITMu9wuAVAxxyEeABkO8QAIkSUAQmQJgBA/pwUgRJYACHGIB0CILAEQ4hAPgBBv4gEQYloCIESWAAix8gBAiGkJgBDTEgAhpiUAQkxLAITM8rslADJMSwCEuFsCIGTO7S8AgK/Zy7wEQIW7JQBC3C0BEOKPLQAIMS0BEOJuCYAQWQIgRJYACJElAEKsPAAQIksAhPjdEgAh7pYACJElAEJkCYAQKw8AhMgSACEO8QAIkSUAQmQJgBBZAiBk3m3pAYAKm3gAhDjEAyBElgAIcYgHQIhpCYAQWQIgRJYACHG3BECIaQmAENMSACGz9u1PAIBfDvEACJElAEJkCYAQWQIgxCYeACGyBECIQzwAQmQJgBBZAiDE3RIAIaYlAEJkCYAQWQIgRJYACJElAELm9X9LAGSYlgAIkSUAQmQJgBCvPAAQYloCIESWAAhxiAdAiGkJgBBZAiBElgAIkSUAQmQJgBBZAiBElgAImbXO7W8AgA8/pwUgxCEeACGyBECIQzwAQkxLAITIEgAhsgRAiCwBECJLAITM2vv2NwDAh2kJgBBZAiBElgAIkSUAQmQJgBBv4gEQYloCIESWAAiRJQBCfgC2RHoZnA3nzwAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 299,
    xlinkShow: "embed"
  }))))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03371 .0333 0 6.2 24.64)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAIAAACaUPOvAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWN8wNLOgBcw4ZceRCoAJGoBd8Il8QwAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eh)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03366 .0333 0 6.364 25.1)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWN8wNLOgBsw4ZEbYGkACmYBdwccj0cAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ei)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ej)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0336 .03343 0 7.117 26.775)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAIAAABV+fA3AAAABmJLR0QA/wD/AP+gvaeTAAAAIklEQVQImWN8wNLOgAMw4ZIgIMfylxGf3H/ccnjM/IfbTAB+RQZ4qQCXUgAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ek)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03319 .03455 0 5.967 23.621)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAECAIAAAA1REndAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWN8wNLOQAgwEVRBVUUA0kMBcxe5v7sAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 4,
    xlinkShow: "embed"
  }))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#em)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03366 .03444 0 6.918 26.413)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAIAAAB1kpiRAAAABmJLR0QA/wD/AP+gvaeTAAAAFElEQVQImWN8wNLOgBsw4ZEbYGkACmYBdwccj0cAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eo)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ep)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03444 .03444 0 9.382 29.567)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAIAAABvrngfAAAABmJLR0QA/wD/AP+gvaeTAAAAHUlEQVQImWOskG9lQAVMDBiA5R8jphCmqv/EaAQAOegFK1ga4UQAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#er)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03444 .03444 0 9.053 29.239)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAIAAABvrngfAAAABmJLR0QA/wD/AP+gvaeTAAAAH0lEQVQImWNskWljQAUs/xjQAcs/RkwhDFVMGCLYhABlGwQz8q7fZAAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#et)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03315 .03302 0 10.333 12.851)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 31,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAABECAIAAAD2hXlaAAAABmJLR0QA/wD/AP+gvaeTAAAAkElEQVRYhe2YyQ3AQAwCceRCUmKaSNvZVODnPEYyBSALMHvUc7/B0B/HnXQKZL9Abpod1v3A7KCtfbyZwXVH2QvkZ2c3u2qend3V1X0CfTZ5G9jsqpnd7CqdGbQj4ft7wNS4d9XbkdsEE8wNzL61zZkxu2pWRn2uon8csDIJeCswZwbfJvJfbPt9wPb7BPPsP9OCKdF1dS0rAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 68,
    xlinkShow: "embed"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03315 .03302 0 10.333 12.851)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 31,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAABECAIAAAD2hXlaAAAABmJLR0QA/wD/AP+gvaeTAAAAkElEQVRYhe2YyQ3AQAwCceRCUmKaSNvZVODnPEYyBSALMHvUc7/B0B/HnXQKZL9Abpod1v3A7KCtfbyZwXVH2QvkZ2c3u2qend3V1X0CfTZ5G9jsqpnd7CqdGbQj4ft7wNS4d9XbkdsEE8wNzL61zZkxu2pWRn2uon8csDIJeCswZwbfJvJfbPt9wPb7BPPsP9OCKdF1dS0rAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 68,
    xlinkShow: "embed"
  }))))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ev)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03343 .03444 0 8.855 29.074)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAIAAACAbBMhAAAABmJLR0QA/wD/AP+gvaeTAAAAI0lEQVQImWPskmpjwABMmEIMDAws/xixif7Hrhar6H9sJgAAc8sFOg85EBoAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ew)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ex)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03295 .03308 0 6.494 16.854)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 37,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAXCAIAAAADThHyAAAABmJLR0QA/wD/AP+gvaeTAAAALUlEQVRIiWN8wNLOQEfARE/LRu0btW/UvlH7Ru0btW/UvlH7hqB9LH8Z6WofAKOVApnQh9w8AAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 23,
    xlinkShow: "embed"
  }))))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ey)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ez)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03449 .03444 0 9.217 29.403)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAIAAACEmcMcAAAABmJLR0QA/wD/AP+gvaeTAAAAIElEQVQImWOsk21jQAJMDKiA5S8jA175f4z/Ufj/UeUB9ssFLi4+8uEAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eA)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eB)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03455 .03312 0 9.484 29.601)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAIAAADtz9qMAAAABmJLR0QA/wD/AP+gvaeTAAAAG0lEQVQImWN00W5lgAEmBiTA9J+B4T92GWQOAIYIAvw1FdnPAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eC)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eD)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03449 .03312 0 9.32 29.471)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAIAAAACDbGyAAAABmJLR0QA/wD/AP+gvaeTAAAAJElEQVQImWN0025jQAIsDAz/UfhwHiMDAwMDAxMDKmCBsyAKAb+WBAVq58LlAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eE)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eF)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.0333 .03312 0 9.156 29.334)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAFCAIAAADpOgqxAAAABmJLR0QA/wD/AP+gvaeTAAAAH0lEQVQImWN0025jYGBg/M8AAYwMDEwMGIA8of8MDAC2AgMB4V9pKQAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eG)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eH)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03366 .03449 0 6.132 24.38)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAIAAADzBuo/AAAABmJLR0QA/wD/AP+gvaeTAAAAHElEQVQImWMsUuhgYGBgZEABjP+hDCYGvICm0gAwugIl23MgOAAAAABJRU5ErkJggg==",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 5,
    xlinkShow: "embed"
  }))))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eI)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eJ)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 18.16 10.059) scale(.03343)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAIAAABLMMCEAAAABmJLR0QA/wD/AP+gvaeTAAAAKklEQVQImWMM1mhjYGBg/M+ADFigXEZUUQiFqpSBiQEbYPqPoRC3WqyiAJlLBhCM+itxAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 7,
    xlinkShow: "embed"
  }))))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eK)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eL)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03353 .03444 0 7.445 27.302)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAABmJLR0QA/wD/AP+gvaeTAAAAJklEQVQImWOMUW1nZEAHjAwMTBiCUEC6BAsDA8N/rDqwiv5nYAAA5rwEFR1OSJYAAAAASUVORK5CYII=",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eM)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eN)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.03353 .0333 0 7.021 26.577)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAABmJLR0QA/wD/AP+gvaeTAAAAGElEQVQImWNMUW5ngAFGBgRgYsAB6CEBAKCYARv/notbAAAAAElFTkSuQmCC",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    height: 6,
    xlinkShow: "embed"
  }))))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eO)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eP)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#eR)",
    d: "M 14.136719 11.53125 L 4.363281 11.53125 L 4.363281 29.910156 L 14.136719 29.910156 Z M 14.136719 11.53125"
  }))))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.1875 0 L 1.1875 -6.90625 L 8.4375 -6.90625 L 8.4375 -6.03125 L 2.171875 -6.03125 L 2.171875 -3.90625 L 7.0625 -3.90625 L 7.0625 -3.015625 L 2.171875 -3.015625 L 2.171875 -0.890625 L 8.59375 -0.890625 L 8.59375 0 Z M 1.1875 0",
    transform: "translate(29.754 21.9)"
  }))))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.65625 0 L 3.65625 -6.03125 L 0.140625 -6.03125 L 0.140625 -6.90625 L 8.140625 -6.90625 L 8.140625 -6.03125 L 4.640625 -6.03125 L 4.640625 0 Z M 3.65625 0",
    transform: "translate(44.209 21.9)"
  }))))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.1875 0 L 1.1875 -6.90625 L 2.171875 -6.90625 L 2.171875 -3.90625 L 7.90625 -3.90625 L 7.90625 -6.90625 L 8.890625 -6.90625 L 8.890625 0 L 7.90625 0 L 7.90625 -3.015625 L 2.171875 -3.015625 L 2.171875 0 Z M 1.1875 0",
    transform: "translate(57.823 21.9)"
  }))))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.1875 0 L 1.1875 -6.90625 L 8.4375 -6.90625 L 8.4375 -6.03125 L 2.171875 -6.03125 L 2.171875 -3.90625 L 7.0625 -3.90625 L 7.0625 -3.015625 L 2.171875 -3.015625 L 2.171875 -0.890625 L 8.59375 -0.890625 L 8.59375 0 Z M 1.1875 0",
    transform: "translate(73.216 21.9)"
  }))))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.203125 0 L 0.34375 -6.5625 L 0.34375 -6.90625 L 1.28125 -6.90625 L 3.875 -0.890625 L 4.078125 -0.890625 L 5.890625 -5.40625 L 5.359375 -6.5625 L 5.359375 -6.90625 L 6.28125 -6.90625 L 8.765625 -0.890625 L 8.953125 -0.890625 L 11.5 -6.90625 L 12.390625 -6.90625 L 12.390625 -6.5625 L 9.59375 0 L 8.109375 0 L 6.453125 -4.03125 L 6.3125 -4.03125 L 4.703125 0 Z M 3.203125 0",
    transform: "translate(87.67 21.9)"
  }))))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.421875 -6.90625 L 9.140625 -0.34375 L 9.140625 0 L 8.203125 0 L 7.171875 -1.828125 L 2.234375 -1.828125 L 1.21875 0 L 0.296875 0 L 0.296875 -0.34375 L 4 -6.90625 Z M 2.734375 -2.71875 L 6.6875 -2.71875 L 4.8125 -6.078125 L 4.609375 -6.078125 Z M 2.734375 -2.71875",
    transform: "translate(105.72 21.9)"
  }))))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.1875 0 L 1.1875 -6.90625 L 7.03125 -6.90625 L 8.671875 -5.546875 L 8.671875 -3.828125 L 7.078125 -2.515625 L 8.9375 -0.34375 L 8.9375 0 L 7.953125 0 L 5.84375 -2.46875 L 2.171875 -2.46875 L 2.171875 0 Z M 2.171875 -3.359375 L 6.59375 -3.359375 L 7.6875 -4.25 L 7.6875 -5.140625 L 6.59375 -6.03125 L 2.171875 -6.03125 Z M 2.171875 -3.359375",
    transform: "translate(120.47 21.9)"
  }))))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.1875 0 L 1.1875 -6.90625 L 8.4375 -6.90625 L 8.4375 -6.03125 L 2.171875 -6.03125 L 2.171875 -3.90625 L 7.0625 -3.90625 L 7.0625 -3.015625 L 2.171875 -3.015625 L 2.171875 -0.890625 L 8.59375 -0.890625 L 8.59375 0 Z M 1.1875 0",
    transform: "translate(135.468 21.9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.809fa9726edb0900ae83b87618b6b17f.svg";
export { ForwardRef as ReactComponent };